import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
    FormControl, InputLabel, Select, MenuItem, Grid, TextField, Box, Button, Tooltip,
    FormControlLabel, Radio, RadioGroup, Stack, IconButton
} from '@mui/material';
import Pagination from "@mui/material/Pagination";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import 'react-phone-input-2/lib/style.css';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../index.css';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TableHead from '@mui/material/TableHead';
import ClearIcon from '@mui/icons-material/Clear';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import {
    Typography, Stepper, Step,
    StepLabel, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, Paper, InputAdornment
} from "@mui/material";
import {
    KeyboardArrowLeft as KeyboardArrowLeftIcon,
    NavigateNext as NavigateNextIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    CancelPresentation as CancelPresentationIcon,
    LocalPrintshop as PrintIcon,
    CheckCircle as CheckCircleIcon
} from "@mui/icons-material";
import Backdrop from '@mui/material/Backdrop';
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import BookingHistory from './BookingHistory';
import OutlinedInput from '@mui/material/OutlinedInput';
import Flag from './Flag'
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import BReport from '../../../atoms/ReportFolder/BReport2';
import BedDetails from './BedAvilableDetails'
import CrudButtons from '../../../../src/GlobalFunction/CrudButtons'
import axiosInstance from '../../../lib/axios';
import axiosInstanceForPG from '../../../lib/axiosFormPG';
import checkAndLock from '../../../GlobalFunction/checkAndLock';
import UnLock from '../../../GlobalFunction/UnLock';
import BillingDetailsModal from '../BConfirmation/ACCGenerateDetailsModal';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import HistoryIcon from '@mui/icons-material/History';
import PaymentsIcon from '@mui/icons-material/Payments';
import CancelIcon from '@mui/icons-material/Cancel';
import RestoreIcon from '@mui/icons-material/Restore';
import RoomSelection from '../../RoomSelection/RoomSelection';
import { usePermissions } from '../../../GlobalFunction/userPermissions';
import ConfirmationDialog from '../../ReusableDailog';
import { useSelector } from 'react-redux';
import { selectGatewayType } from '../../../redux/propertySlice';

const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

const BASE_COLUMNS = [
    { id: 'WingName', label: 'Wing', minWidth: 40, maxWidth: 40, width: 40 },
    { id: 'FloorName', label: 'Floor', minWidth: 40, maxWidth: 40, width: 40 },
    { id: 'RoomTypeName', label: 'Type', minWidth: 60, maxWidth: 60, width: 60 },
    { id: 'RoomViewNAme', label: 'View', minWidth: 40, maxWidth: 40, width: 40 },
    { id: 'RoomBedTypeName', label: 'BType', minWidth: 40, maxWidth: 40, width: 40 },
    { id: 'RoombedName', label: 'BedNo', minWidth: 30, maxWidth: 30, width: 30 },
    { id: 'BedRent', label: 'Rent', minWidth: 30, maxWidth: 30, width: 30 },
];

const BASE_COLUMNSCAT = [
    { id: 'RoomTypeName', label: 'Room Type', minWidth: 120 },
    { id: 'RoomBedTypeName', label: 'Bed Type', minWidth: 120 },
    { id: 'RoomViewName', label: 'View', minWidth: 70 },
    { id: 'BedRent', label: 'Rent', minWidth: 80 },
];

// Function to generate columns based on API response
const generateColumnsFromData = (apiData, startDate, endDate) => {
    const baseColumnWidths = {
        RoomTypeName: 120,
        RoomBedTypeName: 120,
        RoomViewName: 100,
        BedRent: 80,
    };

    const baseColumns = BASE_COLUMNSCAT.map(col => ({
        ...col,
        minWidth: baseColumnWidths[col.id],
        maxWidth: baseColumnWidths[col.id],
        width: baseColumnWidths[col.id]
    }));

    // Extract unique month-year combinations from API data
    const monthColumns = new Set();

    if (apiData && apiData.length > 0) {
        apiData.forEach(item => {
            Object.keys(item).forEach(key => {
                // Check if key matches pattern "YYYY-MonthName"
                if (key.match(/^\d{4}-[A-Za-z]+$/)) {
                    monthColumns.add(key);
                }
            });
        });
    }

    // Sort month columns chronologically
    const sortedMonthColumns = Array.from(monthColumns).sort((a, b) => {
        const [yearA, monthA] = a.split('-');
        const [yearB, monthB] = b.split('-');

        if (yearA !== yearB) {
            return parseInt(yearA) - parseInt(yearB);
        }

        const monthIndexA = MONTHS.findIndex(m => m === monthA);
        const monthIndexB = MONTHS.findIndex(m => m === monthB);
        return monthIndexA - monthIndexB;
    });

    // Generate columns with year headers
    const dynamicColumns = [];
    let currentYear = null;

    sortedMonthColumns.forEach(monthKey => {
        const [year, month] = monthKey.split('-');

        // Add year column if it's a new year
        if (currentYear !== year) {
            dynamicColumns.push({
                id: `year_${year}`,
                label: year,
                minWidth: 50,
                maxWidth: 50,
                width: 50,
                isYearColumn: true
            });
            currentYear = year;
        }

        // Add month column
        dynamicColumns.push({
            id: monthKey,
            label: month.substring(0, 3), // Short month name
            minWidth: 60,
            maxWidth: 60,
            width: 60,
            isMonthColumn: true
        });
    });

    return [...baseColumns, ...dynamicColumns];
};

// Function to transform API data for table
const transformApiData = (apiData) => {
    if (!apiData || !Array.isArray(apiData)) {
        return [];
    }

    return apiData.map(item => {
        const transformedItem = {
            BedCatId: item.BedCatId,
            PropId: item.PropId,
            PropName: item.PropName,
            RoomTypeId: item.RoomTypeId,
            RoomTypeName: item.RoomTypeName,
            RoomViewName: item.RoomViewName || '',
            RoomBedTypeId: item.RoomBedTypeId,
            RoomBedTypeName: item.RoomBedTypeName,
            BedRent: item.BedRent,
        };

        // Add month data and year data
        Object.keys(item).forEach(key => {
            if (key.match(/^\d{4}-[A-Za-z]+$/)) {
                // This is a month column
                transformedItem[key] = item[key];

                const year = key.split('-')[0];
                transformedItem[`year_${year}`] = year;
            }
        });

        return transformedItem;
    });
};

const Precheckin = () => {
    const { register, setValue, reset, watch } = useForm();
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [BookId, setBookId] = useState(-1);
    const [Mode, setMode] = useState("add");
    const [PlanDrp, setPlanDrp] = useState([]);
    const [TransactionData, setTransactionData] = useState([]);
    const [SelectedRow, setSelectedRow] = useState({});
    const [PropertyDrp, setPropertyDrp] = useState([]);
    const [TopUpDrp, setTopUpDrp] = useState([]);
    const [PromoCodeID, setPromoCodeID] = useState(-1);
    const [HistoryData, setHistoryData] = useState([]);
    const [openConfirmDialog, setopenConfirmDialog] = useState(false);
    const [MobileNo, setMobileNo] = useState('');
    const [todayDate, setTodayDate] = useState(moment(new Date()).format("MM-DD-YYYY"));
    const [ResidentId, setResidentId] = useState(-1);
    const [page, setPage] = useState(0);
    const [searchTerms, setSearchTerms] = useState({});
    const [rows, setRows] = useState([]);
    const [isDepositPaid, setIsDepositPaid] = useState('');
    const [AllDisUnable, setAllDisUnable] = useState(true);
    const [selectedImage, setselectedImage] = useState(Flag);
    const navigate = useNavigate();
    const location = useLocation();
    const [OpenHistoryTableDialog, setOpenHistoryTableDialog] = useState(false);
    const [OpenHistoryTableDialog1, setOpenHistoryTableDialog1] = useState(false);
    const [OpenDForDelete, setOpenDForDelete] = useState(false);
    const [OpenDForCancel, setOpenDForCancel] = useState(false);
    const [MobDigit, setMobDigit] = useState(10);
    const [TransPlanDrp, setTransPlanDrp] = useState([]);
    const [MessPlanDrp, setMessPlanDrp] = useState([]);
    const [OpenLoader, setOpenLoader] = useState(false);
    const [selectedBedData, setSelectedBedData] = useState(null);
    const [tableColumns, setTableColumns] = useState(BASE_COLUMNS);
    const [Loader, setLoader] = useState(false);
    const [openBillingModal, setOpenBillingModal] = useState(false);
    const [isBookingConfirmed, setIsBookingConfirmed] = useState(false);
    const [billingDetails, setBillingDetails] = useState(null);
    const [PlanDataState, setPlanDataState] = useState(null);
    const [PayAdvice, setPayAdvice] = useState(null);
    const [SummaryReport, setSummaryReport] = useState(null);
    const [ReceiptSummary, setReceiptSummary] = useState(null);
    const [PayGenerate, setPayGenerate] = useState(null);
    const [PendingDetails, setPendingDetails] = useState(null);
    const [fontSize, setFontSize] = useState('1rem');
    // const permissions = useModulePermissions("Booking");
    const contentRef = useRef(null);
    const baseUrl = window.location.origin;
    const [openRenewalPopup, setOpenRenewalPopup] = useState(false);
    const [renewalData, setRenewalData] = useState(null);
    const [unit, setUnit] = useState('')
    const [lastId, setLastId] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { OcupntMob, EnqId } = location.state || {};
    const [regenerate, setRegenerate] = useState(false);
    const [openConfirmGen, setOpenConfirmGen] = useState(false);
    const [oldBedId, setOldBedId] = useState('')
    const [openCategoryModal, setOpenCategoryModal] = useState(false);
    const [categoryColumns, setCategoryColumns] = useState(BASE_COLUMNS);
    const [categoryRows, setCategoryRows] = useState([]);
    const [categoryLoader, setCategoryLoader] = useState(false);
    const [OpenHistoryTable, setOpenHistoryTable] = useState(false);
    const [DateFrom, setDateFrom] = React.useState(dayjs(new Date));
    const [DateTo, setDateTo] = React.useState(dayjs('MM-DD-YYYY'));
    const [couponStatus, setCouponStatus] = useState('checking');
    const [couponData, setCouponData] = useState(null);
    const [openOtpDialog, setOpenOtpDialog] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const permissions = usePermissions("Payment Advice")
    const UtType = sessionStorage.getItem("UtType");
    const gatewayType = useSelector(selectGatewayType);

    const handleApplyCoupon = async () => {
        try {
            const mobileNo = watch('MobileNo');

            if (!mobileNo || mobileNo.length !== MobDigit) {
                toast.error("Please enter a valid mobile number first");
                return;
            }

            const response = await axiosInstance.post(`ResidentMst/RetriveResidentMstAll`, {
                ResidentId: 1,
                Flag: "M",
                Mobile: mobileNo.trim()
            });

            if (response.data.Status === 0 && response.data.Data.MstResidentList[0]) {
                const residentData = response.data.Data.MstResidentList[0];
                const { CouponNo, DiscType, DiscountAmt, DiscAmt, CouponId } = residentData;

                if (CouponNo) {
                    setValue("CouponNo", CouponNo);
                    setValue("DiscType", DiscType);
                    setValue("DiscountAmt", DiscountAmt || 0);
                    setValue("DiscAmt", DiscAmt || 0);
                    setValue("CouponId", CouponId);
                    setValue("AMTDISCOUNT", DiscAmt);

                    toast.success("Coupon applied successfully!");

                    // Recalculate amounts after applying coupon
                    handleCalulate();
                } else {
                    toast.info("No coupon available for this resident");
                }
            } else {
                toast.error("Resident not found or no coupon data available");
            }
        } catch (error) {
            toast.error("Error applying coupon");
        }
    };

    useEffect(() => {
        const checkCouponAvailability = async () => {
            const mobileNo = watch('MobileNo');

            if (!mobileNo || mobileNo.length !== MobDigit) {
                setCouponStatus('checking');
                return;
            }

            try {
                setCouponStatus('checking');
                const response = await axiosInstance.post(`ResidentMst/RetriveResidentMstAll`, {
                    ResidentId: 1,
                    Flag: "M",
                    Mobile: mobileNo.trim()
                });

                if (response.data.Status === 0 && response.data.Data.MstResidentList[0]) {
                    const residentData = response.data.Data.MstResidentList[0];

                    if (residentData.CouponNo) {
                        setCouponStatus('available');
                        setCouponData(residentData);
                    } else {
                        setCouponStatus('unavailable');
                        setCouponData(null);
                    }
                } else {
                    setCouponStatus('unavailable');
                    setCouponData(null);
                }
            } catch (error) {
                setCouponStatus('unavailable');
                setCouponData(null);
            }
        };
        const timeoutId = setTimeout(checkCouponAvailability, 500);
        return () => clearTimeout(timeoutId);
    }, [watch('MobileNo')]);

    useEffect(() => {
        setCouponStatus('checking');
        setCouponData(null);
    }, [watch('MobileNo')]);

    useEffect(() => {
        const calculateDates = () => {
            const checkinDt = watch('CheckinDt');
            const duration = watch('Duration');
            if (checkinDt && duration) {
                const startDate = moment(checkinDt);
                let newDate;
                const durationStr = String(duration);
                if (durationStr.includes(".")) {
                    const numarr = durationStr.split(".");
                    newDate = startDate.add(parseInt(numarr[1]), "days").subtract(1, 'day').format('YYYY-MM-DD');
                } else {
                    newDate = startDate.add(parseInt(durationStr), "months").subtract(1, 'day').format('YYYY-MM-DD');
                }

                if (newDate !== "Invalid date") {
                    setValue('BookUpToDt', newDate);
                    setValue('CheckoutDt', newDate);
                    setBillFunc();
                }
            }
        };

        calculateDates();
    }, [watch('CheckinDt'), watch('Duration')]);

    useEffect(() => {
        if (OpenHistoryTableDialog) {
            if (watch("bookingType") === "renewal" || watch("bookingType") === "extend") {
                setSearchTerms(prev => ({ ...prev, RoombedName: unit }));
            } else {
                setSearchTerms(prev => ({ ...prev, RoombedName: "" }));
            }
        }
    }, [OpenHistoryTableDialog, unit, watch("bookingType")]);
    const handlePrint = useReactToPrint({ contentRef });

    const fetchCategoryData = async () => {
        try {
            setCategoryLoader(true);
            const bookFromDt = watch('CheckinDt');
            const bookUpToDt = watch('CheckoutDt');

            if (!bookFromDt || !bookUpToDt) {
                toast.error("Please set booking dates first");
                return;
            }
            await axiosInstance.post(`BedCalendar/InsertBedCat`,
                { "PropId": watch('PropId'), Flag: "" }
            );

            await axiosInstance.post(`BedCalendar/InsertBedCatCal`,
                { "PropId": watch('PropId'), Flag: "" }
            );
            await axiosInstance.post(`BedCalendar/UpdateBedCat`,
                { "PropId": watch('PropId'), Flag: "" }
            );

            // Call UpdateBedCatCal API
            await axiosInstance.post(`BedCalendar/UpdateBedCatCal`,
                { "PropId": watch('PropId'), Flag: "" }
            );
            const response = await axiosInstance.post(`BedCalendar/GenerateBedCatCal`,
                {
                    PropId: watch("PropId"),
                    BookDtFrom: dayjs(bookFromDt).format("YYYY-MM-DD"),
                    CheckoutDt: dayjs(bookUpToDt).format("YYYY-MM-DD"),
                    Flag: "",
                }
            );

            if (response?.data?.Status === 0) {
                const apiData = response.data.Data?.BedCatCalList || [];
                const newColumns = generateColumnsFromData(apiData, dayjs(bookFromDt), dayjs(bookUpToDt));
                setCategoryColumns(newColumns);

                const transformedData = transformApiData(apiData);
                setCategoryRows(transformedData);
            } else {
                toast.error(response?.data?.Message || "Error fetching category data");
                setCategoryRows([]);
            }
        } catch (error) {
            toast.error("Failed to fetch category data");
        } finally {
            setCategoryLoader(false);
        }
    };

    // useEffect(() => {
    //     const fetchData = async () => {
    //         await fetchPropertyData();
    //         await fetchTransPlanDrp();
    //         await fetchMessPlanDrp();

    //         if (location.state) {
    //             const mobileNo = location.state.MobileNo?.MobileNo;

    //             if (mobileNo) {
    //                 // await handleMobileChange(null, null, mobileNo);
    //             }
    //             console.log('mode7', location.state)
    //             setAllDisUnable(false);
    //             let BookId = location.state.BookId;
    //             await fetchTransactionData(BookId.BookId, "R")
    //             setBookId(location.state.BookId);

    //         } else {
    //             setMode("add");
    //             setAllDisUnable(true);
    //         }
    //         // await fetchRoomNoData();
    //         // await fetchRoomBedNoData();
    //     }

    //     fetchData();
    // }, []);

    useEffect(() => {
        const fetchData = async () => {
            await fetchPropertyData();
            await fetchTransPlanDrp();
            await fetchMessPlanDrp();

            const query = new URLSearchParams(location.search);
            const bookId = query.get('BookId');
            const modeFromQuery = query.get('mode') || 'add'; // Get mode from URL
            if (bookId && modeFromQuery === 'view') {
                setMode('view'); // Set mode to view
                setAllDisUnable(false);
                await fetchTransactionData(bookId, 'R'); // Fetch booking data
                setBookId(bookId); // Set BookId
            } else if (location.state) {
                const mobileNo = location.state.MobileNo?.MobileNo;
                if (mobileNo) {

                }
                setAllDisUnable(false);
                let BookId = location.state.BookId;
                await fetchTransactionData(BookId.BookId, 'R');
                setBookId(location.state.BookId);
            } else {
                setMode('add');
                setAllDisUnable(true);
            }
        };
        fetchData();
    }, []);

    const mobileNoFromQuery = new URLSearchParams(window.location.search).get('MobileNo');
    useEffect(() => {
        if (OcupntMob && OcupntMob.length === MobDigit) {
            setValue('MobileNo', OcupntMob);
            setMobileNo(OcupntMob);
            handleMobileChange({ target: { value: OcupntMob } }, "add", null);
        }
    }, [OcupntMob, MobDigit, setValue]);

    useEffect(() => {
        if (OcupntMob && OcupntMob.length === MobDigit) {
            setValue('MobileNo', OcupntMob);
            setMobileNo(OcupntMob);
            handleMobileChange({ target: { value: OcupntMob } }, "add", null);
        }

        else if (mobileNoFromQuery && mobileNoFromQuery.length === MobDigit) {
            setValue('MobileNo', mobileNoFromQuery, { shouldValidate: true, shouldDirty: true });
            setMobileNo(mobileNoFromQuery);
            handleMobileChange({ target: { value: mobileNoFromQuery } }, "add", null);
        }

    }, [mobileNoFromQuery, setValue, OcupntMob, MobDigit]);

    useEffect(() => {

        if (tableColumns.length >= (parseInt(watch("Duration")) + 8) && rows.length > 0) {
            setTimeout(() => {
                setLoader(false);
            }, 1000);

        }
    }, [tableColumns, rows]);

    useEffect(() => {
        setValue('BookDtFrom', todayDate);
        setValue('BookDt', todayDate);
    }, [todayDate]);

    useEffect(() => {
        if (TransactionData.length > 0 && Mode != "add") {
            const obj = watch();
            for (let key in obj) {
                if (TransactionData[0].hasOwnProperty(key)) {
                    setValue(key, TransactionData[0][key]);
                } else {
                    setValue(key, "");

                }
            }
            const apiBookingType = TransactionData[0].BookingType === "R" ? "renewal" : "new";
            setValue("bookingType", apiBookingType);
            setValue("PlanName", TransactionData[0].PlanName);
            setValue("PropName", TransactionData[0].PropName);
            setValue("PytAdvId", TransactionData[0].PytAdvId);
            setValue("PytAdvNo", TransactionData[0].PytAdvNo);
            setValue("BookStatus", TransactionData[0].BookStatus);
            setValue("CreatedName", TransactionData[0].CreatedName);
            setValue("UpdatedName", TransactionData[0].UpdatedName);
            setResidentId(TransactionData[0].ResidentId);
            setValue("Addr", TransactionData[0].Addr);
            setValue("AMTDISCOUNT", TransactionData[0].DiscountAmt);
            setValue("CouponId", TransactionData[0].CouponId);
            handlePropertyWiseImage(TransactionData[0]['PropId']);
            // handleMobileChange({ target: { value: TransactionData[0].MobileNo } }, "view");
            let getObj = TransPlanDrp.find(obj => obj.TransPlanID === TransactionData[0].TransPlanId);
            if (getObj) {
                setValue("TrspChrg", getObj.Amount);
                setValue("TransPlanId", getObj.TransPlanID);
            }
            let getObjM = MessPlanDrp.find(obj => obj.MessPlanID === TransactionData[0].MessPlanId);
            if (getObjM) {
                setValue("MessChrg", getObjM.Amount);
                setValue("MessPlanId", getObjM.MessPlanID);
            }
            setTmt();
            const fetchingData = async () => {
                await fetchPlanDrpData();
                await fetchRoomSelectionData(TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, "Retreive");
                await fetchTopUpData(TransactionData[0].RoomTypeId, "view");
                await fetchHistoryData(TransactionData[0]['ResidentId'])
                // await fetchRoomBedData(TransactionData[0].RoomBedId, TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, TransactionData[0].PropId);
            }

            fetchingData()
        } else if (Mode === "add") {
            handleAddClick();
        }
    }, [TransactionData, Mode]);

    useEffect(() => {
        const handleFetchData = (event) => {
            // Ensure the event action matches
            if (event.data?.action === "fetchBedData") {
                const savedBedData = localStorage.getItem("selectedBedData");
                if (savedBedData) {
                    try {
                        const bedData = JSON.parse(savedBedData);

                        setValue("WingName", bedData.WingName || "");
                        setValue("FloorName", bedData.FloorName || "");
                        setValue("RoomTypeName", bedData.RoomTypeName || "");
                        setValue("RoomViewNAme", bedData.RoomViewNAme || "");
                        setValue("RoomBedTypeName", bedData.RoomBedTypeName || "");
                        setValue("RoombedName", bedData.RoombedName || "");
                        setValue("BedRent", bedData.BedRent || 0);
                        localStorage.removeItem("selectedBedData");
                    } catch (error) {
                        console.error("Error parsing bed data from localStorage:", error);
                    }
                }
            }
        };

        window.addEventListener("message", handleFetchData);

        return () => {
            window.removeEventListener("message", handleFetchData);
        };
    }, []);

    useEffect(() => {
        const updateFontSize = () => {
            const width = window.innerWidth;
            if (width <= 600) {
                setFontSize('0.rem'); // Small screen font size
            } else if (width <= 960) {
                setFontSize('1rem'); // Medium screen font size
            } else {
                setFontSize('1.125rem'); // Large screen font size
            }
        };

        updateFontSize();

        // Add resize event listener
        window.addEventListener('resize', updateFontSize);
        return () => window.removeEventListener('resize', updateFontSize);
    }, []);

    const handlePropertyWiseImage = (value) => {
        let obj = PropertyDrp.find(objD => objD.Id === value);
        obj ? setselectedImage(obj.CountryIcon) : setselectedImage("");
        obj && setMobDigit(obj.MobDigit);
    }

    const fetchRoomSelectionData = async (date, date1, ByMode) => {
        date = moment(new Date(date)).format("YYYY-MM-DD");
        const formattedDate = moment(new Date(date1)).format("YYYY-MM-DD");
        if (ByMode === "Retreive") {

            try {
                const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
                    BookFromDt: date,
                    BookToDt: formattedDate,
                    PropId: watch('PropId'),
                    Flag: "",
                    RoomBedId: TransactionData[0].RoomBedId,
                },);

                if (response.data.Status === 0) {

                    let row = response.data.Data[0];
                    const { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName } = row;
                    const obj = { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName };
                    for (let key in obj) {
                        setValue(key, row[key]);
                    }
                    setSelectedRow(row);
                    setSelectedBedData(row);
                } else {
                    setRows([]);
                }
            } catch (error) {
                console.error('Error fetching company data:', error);
            }
        } else {
        }
        setPage(0);
    };

    const fetchTransactionData = async (BookId, Flag) => {
        try {
            const response = await axiosInstance.post(`TrnBooking/RetriveTrnBooking`, {
                BookId,
                Flag,
                CreatedBy: UserId
            });
            if (response.data.Status === 0) {

                if (Flag === "D") {
                    toast.success(response.data.Message, { autoClose: 1000 });
                    fetchTransactionData(BookId, "L");
                    return;
                }
                let Data = response.data.Data != null ? response.data.Data : [];
                setTransactionData(Data);
                setBookId(response.data.Data[0].BookId);
                setLastId(response.data.Data[0].LastBookId)
                setOldBedId(response.data.Data[0].RoomBedId)
                setIsDepositPaid(response.data.Data[0].isDepositPaid)
                setValue("RoomTypeId", Data[0].RoomTypeId);
                setValue("RoomViewId", Data[0].RoomViewId);
                setValue("RoomBedTypeId", Data[0].RoomBedTypeId);
                setValue("BedCatId", Data[0].BedCatId);
                setValue('CheckinDt', Data[0].CheckinDt)
                setValue('PropId', Data[0].PropId)
                setValue('BookId', Data[0].BookNo)
                setValue('RoombedName', Data[0].RoombedName)
                setValue('RoomViewNAme', Data[0].RoomViewNAme)
                setValue('RoomBedId ', Data[0].RoomBedId)
                if (Data[0]?.IsAccGen === "G") {
                    setRegenerate(true);  // Show "Regenerate"
                } else if (Data[0]?.IsAccGen === "N") {
                    setRegenerate(false); // Show "Acc Gen"
                }
                const apiBookingType = Data[0].BookingType === "R" ? "renewal" : "new";
                setValue("bookingType", apiBookingType);
                setMode("view");
                let Column = [...BASE_COLUMNS, { id: 'action', label: 'Action', minWidth: 30 }];
                setTableColumns(Column);
            } else {
                if (Flag != "D") {
                    setBookId(-1);
                    Mode === "view" ? setMode("add") : handleAddClick();
                }
                toast.info(response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching Transaction  data:', error);
        }
    }

    const fetchPropertyData = async () => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(`PropertyMst/GetPropertyMstUserwisedrp`,
                { Flag, UserId },
            );

            if (response.data.Status === 0) {
                setPropertyDrp(response.data.Data);
                // setValue("PropId", response.data.Data[0].Id);
                setValue("Name", response.data.Data[0].Name);
                fetchPlanDrpData();
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    const fetchTransPlanDrp = async () => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(`MstTransPlan/getMstTransPlandrp`,
                { Flag, UserId },

            );
            if (response.data.Status === 0) {
                setTransPlanDrp(response.data.Data);
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    const fetchMessPlanDrp = async () => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(`MstMessPlan/getMstMessPlandrp`,
                { Flag, UserId },
            );
            if (response.data.Status === 0) {
                setMessPlanDrp(response.data.Data);
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    const fetchPlanDrpData = async () => {
        const Flag = Mode === "add" ? "" : "R";
        try {
            const response = await axiosInstance.post(`MstRoomPlan/getMstRoomPlandrp`,
                { Flag, PropId: watch("PropId") },
            );

            if (response.data.Status === 0) {
                setPlanDrp(response.data.Data);
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    const fetchHistoryData = async (ResidentId) => {
        try {
            const response = await axiosInstance.post(`ResidentHis/GetResidentHistory`,
                { ResidentId },
            );
            if (response.data.Status === 0) {
                setHistoryData(response.data.Data);
            } else {
                setHistoryData([]);
            }
        } catch (error) {
            toast.error('Error fetching resident data');
        }
    };

    const handlePropDurationChange = (name, value = String(watch('Duration'))) => {
        if (watch('Duration') === "") return;
        const date = new Date(watch('BookDtFrom'));
        const startDate = moment(watch('BookDtFrom'));
        if (value.includes(".")) {
            let numarr = value.split(".")

            // var newDate = moment(watch('BookDtFrom')).add(parseInt(numarr[1]), "days").format('MM-DD-YYYY');
            var newDate = startDate.add(parseInt(numarr[1]), "days").subtract(1, 'day').format('MM-DD-YYYY');
        } else {
            // newDate = moment(watch('BookDtFrom')).add(watch('Duration'), "months").format('MM-DD-YYYY');
            newDate = startDate.add(watch('Duration'), "months").subtract(1, 'day').format('MM-DD-YYYY');
        }

        if (newDate !== "NaN") {
            setValue('BookUpToDt', newDate);
            setValue('CheckoutDt', newDate);
            setBillFunc();
            fetchRoomSelectionData(date, newDate, "Insert");
        }
    };

    const setBillFunc = () => {
        const date = new Date(watch('CheckoutDt'));
        const day = date.getDate();
        day <= 15 ? setValue("BillCycle", "F") : setValue("BillCycle", "S");
    }

    const handlePropertyChange = (e) => {
        const { name, value } = e.target;

        if (name === "Duration" && (value === "0" || value === 0)) {
            toast.error("Duration cannot be zero");
            return;
        }
        setValue(name, value);
        setLoader(true);

        if (name === "Duration" || name == "BookDtFrom") {
            // Handle discount calculations
            if ((name === "Duration" && watch("CouponNo") != "") &&
                (watch("DiscType") === "F" || watch("DiscType") === "M")) {
                if (watch("DiscType") === "F") {
                    setValue("DiscAmt", watch("AMTDISCOUNT"));
                } else if (watch("DiscType") === "M") {
                    setValue("DiscAmt", watch("AMTDISCOUNT") * watch("Duration"));
                    setValue("DiscountAmt", watch("AMTDISCOUNT"));
                }
            }

            setValue("AdvcRcble", 0);
            setTmt();

            // Only reset room details if duration is increased
            if (name === "Duration" && Mode === "view") {
                const prevDuration = TransactionData[0]?.Duration || 0;
                const newDuration = parseInt(value) || 0;

                if (newDuration > prevDuration) {
                    const roomFields = {
                        WingName: '',
                        FloorName: '',
                        RoomTypeName: '',
                        RoomViewNAme: '',
                        RoomBedTypeName: '',
                        RoombedName: '',
                        BedRent: 0,
                        TotalRent: 0,
                        NetAmt: 0,
                        MonthlyAmt: 0,
                        AdvcRcble: 0
                    };

                    for (let key in roomFields) {
                        setValue(key, roomFields[key]);
                    }
                    setSelectedRow({});
                }
            }

            handlePropDurationChange(name, value);
        }
        else if (name === 'PropId') {
            fetchPlanDrpData(value);
            handlePropDurationChange(name);
            handlePropertyWiseImage(value);
            let obj = PropertyDrp.find(Iobj => Iobj.Id === value);

            if (obj) {
                setValue("Name", obj.Name);
            }

            setValue("RoomPlanId", '');
            const {
                PlanTenur, FreeMonth, LastAdjMonths, IncRentPerc, TotalInstall, TotalRent, DepositAmt
            } = watch()
            const new1obj = {
                PlanTenur,
                FreeMonth,
                LastAdjMonths,
                IncRentPerc,
                TotalInstall,
                DepositAmt
            }
            for (let key in new1obj) {
                setValue(key, 0);
            }
        }

        if (name === 'PropId') {
            const roomFields = {
                WingName: '',
                FloorName: '',
                RoomTypeName: '',
                RoomViewNAme: '',
                RoomBedTypeName: '',
                RoombedName: '',
                BedRent: 0,
                TotalRent: 0,
                NetAmt: 0,
                MonthlyAmt: 0,
                AdvcRcble: 0
            };

            for (let key in roomFields) {
                setValue(key, roomFields[key]);
            }
            setSelectedRow({});
            setRows([]);
        }
    };

    const resetFunc = () => {

        reset({
            "PropId": '',
            "BookDtFrom": moment(todayDate).format("yyyy-MM-DD"),
            "BookDt": moment(todayDate).format("yyyy-MM-DD"),
            "BookNo": "",
            "FirstName": "",
            "LastName": "",
            "Email": "",
            "BookRef": "",
            "Duration": "",
            "BookUpToDt": "",
            "CheckoutDt": "",
            "WingName": "",
            "FloorName": "",
            "RoomTypeName": "",
            "RoomViewNAme": "",
            "RoomBedTypeName": "",
            "ResidentName": "",
            "RoombedName": "",
            "RoomPlanId": "",
            "PromoCodeName": "",
            "PromoDiscAmt": "",
            "BookRemark": "",
            "MobileNo": "",
            "DiscType": "",
            "DiscountAmt": 0,
            "TotalRent": 0,
            "AdvcRcble": 0,
            // "DepositeAmt": 0,
            "DepositAmt": 0,
            "DiscAmt": 0,
            "PlanTenur": 0,
            "FreeMonth": 0,
            "LastAdjMonths": 0,
            "IncRentPerc": 0,
            "TotalInstall": watch("TotalInstall"),
            "NetAmt": 0,
            "MonthlyAmt": 0,
            "TransPlanId": 1,
            "TrspChrg": 0,
            "MessPlanId": 1,
            "MessChrg": 0,
            "TAmount": 0,
            "MAmount": 0,
            "Tamt": 0,
            "TotNetAmt": 0,
            "TopupAmt": 0,
            "bookingType": "new",
            "MinAdjMonths": ''
        })
        // setMobileNo("91");
        setValue("BookDtFrom", moment(todayDate).format("yyyy-MM-DD"));
        setResidentId(-1);
        setSelectedRow({});
        setPromoCodeID(-1);
        setPlanDrp([]);
    }

    useEffect(() => {
        handleCalulate();
    }, [watch("BedRent")]);

    const handleSubmitClick = async () => {

        if (ResidentId === -1) {
            toast.info("Enter Valid Mobile Number ");
            return;
        }

        else if (watch("RoomPlanId") === "") {
            toast.info("Select Plan");
            return;
        }
        const roomBedId = SelectedRow.RoomBedId || watch('RoomBedId') || TransactionData[0]?.RoomBedId || 1;

        try {
            const roomCheckResponse = await axiosInstance.post('BedCalendar/GetPropWiseBedCalendarMonthRoomBed', {
                RoomBedId: selectedBedData.RoomBedId,
                PropId: watch('PropId'),
                // BookDtFrom: watch('BookDtFrom'),
                BookDtFrom: DateFrom.format('YYYY-MM-DD'),
                CheckoutDt: watch('BookUpToDt'),
                Flag: "",
                BedCatId: watch("BedCatId"),
                OldRoomBedId: oldBedId
            });

            if (roomCheckResponse.data.Status === 0) {
                toast.error(roomCheckResponse.data.Message);
                return
            }
        } catch (error) {
            toast.error("Error checking room availability");
            return;
        }
        const Obj = watch();
        const bookingType = watch("bookingType") === "new" ? "N" : "R";

        let Payload = {
            "BookDt": watch('BookDt'),
            "PropId": watch('PropId'),
            "ResidentId": ResidentId,
            "MobileNo": watch('MobileNo'),
            "RoomTypeId": watch("RoomTypeId") || 1,
            "RoomViewId": watch("RoomViewId") || 1,
            "RoomBedTypeId": watch("RoomBedTypeId") || 1,
            "BedCatId": watch("BedCatId"),
            "RoomTypeId": watch('RoomTypeId'),
            "PlanTenur": watch('PlanTenur'),
            "RoomViewId": SelectedRow.RoomViewId || 1,
            "RoomId": SelectedRow.RoomId || watch('RoomId'),
            "Duration": parseInt(watch('Duration')),
            "DepositeAmt": watch('DepositAmt') ? parseInt(watch('DepositAmt')) : 0,
            "AdvcRcble": watch('AdvcRcble') || 0,
            "BedRent": watch("BedRent") || SelectedRow.BedRent || 1,
            "EnqId": 1,
            "BookDtFrom": watch('BookDtFrom'),
            "BookUpToDt": watch('BookUpToDt'),
            "RoomBedId": roomBedId,
            "RoomBedTypeId": watch('RoomBedTypeId'),
            "CheckinDt": watch('CheckinDt'),
            "CheckoutDt": watch('CheckoutDt'),
            "RoomPlanId": watch('RoomPlanId') !== "" ? parseInt(watch('RoomPlanId')) : 1,
            "PromoDiscAmt": watch('PromoDiscAmt') || 0,
            "FreeMonth": watch("FreeMonth") || 0,
            "BookSt": Mode === "add" ? "B" : TransactionData[0]?.BookSt,
            "CancelReason": "No Show",
            "BookRef": watch('BookRef'),
            "BookRefId": 1,
            "BookRemark": watch('BookRemark'),
            "DiscType": watch("DiscType") || '',
            "PerMonthAmt": 0,
            "ChargeMonths": 0,
            "MonthId": 1,
            "MonthlyAmt": watch("MonthlyAmt") || 0,
            "MonthlyDisc": (watch("BedRent") - watch("MonthlyAmt")),
            "MonthlyNetAmt": watch("MonthlyAmt") || 0,
            "CouponId": watch('CouponId') || 1,
            "CouponNo": watch('CouponNo') || '',
            "CrType": "P",
            "TopupId": watch('TopupId') || 0,
            "Topupdays": watch('Topupdays') || 0,
            "TopupAmt": watch('TopupAmt') || 0,
            "NetAmt": watch('NetAmt') ? parseInt(watch('NetAmt')) : 0,
            "Status": "1",
            "CreatedBy": parseInt(UserId),
            "BillCycle": watch('BillCycle'),
            "FreeMonthValue": 150.00,
            "TotalRent": watch('TotalRent') || 0,
            "DepRctId": 0,
            "DepRctDt": "2024-12-24T10:00:00",
            "DepRctAmt": 0.00,
            "DepBalAmt": 0.00,
            "PaymentSt": "P",
            "MonthName": "December",
            "DiscAmt": watch('DiscAmt'),
            "TrspChrg": watch('TrspChrg'),
            "TotNetAmt": watch("TotNetAmt"),
            "TransPlanId": watch("TransPlanId") || 1,
            "MessPlanId": watch("MessPlanId") || 1,
            "MessChrg": watch("MessChrg"),
            // "FirstName": watch("FirstName"),
            // "LastName": watch("LastName"),
            // "DiscountAmt": watch("AMTDISCOUNT"),
            "BookingType": bookingType,
        };

        if (bookingType === "R") {
            Payload.LastBookId = lastId;
        } else {
            Payload.LastBookId = 1;
        }

        setIsSubmitting(true);

        try {
            let bookingResponse;

            if (Mode === "add") {
                bookingResponse = await axiosInstance.post(`TrnBooking/InsertTrnBooking`,
                    Payload
                );
                if (bookingResponse.data.Status === 0) {
                    await axiosInstance.post(`BedCalendar/InsertBedCat`,
                        { "PropId": watch('PropId'), Flag: "" }
                    );

                    await axiosInstance.post(`BedCalendar/InsertBedCatCal`,
                        { "PropId": watch('PropId'), Flag: "" }
                    );
                    await axiosInstance.post(`BedCalendar/UpdateBedCat`,
                        { "PropId": watch('PropId'), Flag: "" }
                    );

                    // Call UpdateBedCatCal API
                    await axiosInstance.post(`BedCalendar/UpdateBedCatCal`,
                        { "PropId": watch('PropId'), Flag: "" }
                    );

                    toast.success(bookingResponse.data.Message, { autoClose: 1000 });
                    setMode("view");
                    setAllDisUnable(false);
                } else {
                    toast.info(bookingResponse.data.Message);
                }
            } else {
                Payload = { ...Payload, BookId: watch('BookId'), BedCatId: watch("BedCatId"), RoomBedId: selectedBedData.RoomBedId, BookNo: watch("BookNo"), UpdatedBy: parseInt(UserId) };
                delete Payload.CreatedBy;
                console.log('update paylod', Payload)
                bookingResponse = await axiosInstance.post(`TrnBooking/UpdateTrnBooking`,
                    Payload
                );

                if (bookingResponse.data.Status === 0) {
                    // Call UpdateBedCat API
                    await axiosInstance.post(`BedCalendar/InsertBedCat`,
                        { Flag: "" }
                    );

                    // Call InsertBedCatCal API
                    await axiosInstance.post(`BedCalendar/InsertBedCatCal`,
                        { Flag: "" }
                    );
                    await axiosInstance.post(`BedCalendar/UpdateBedCat`,
                        { Flag: "" }
                    );

                    // Call UpdateBedCatCal API
                    await axiosInstance.post(`BedCalendar/UpdateBedCatCal`,
                        { Flag: "" }
                    );

                    toast.success(bookingResponse.data.Message, { autoClose: 1000 });
                    // await UnLock(BookId, "TrnBooking", "BookId");
                    // fetchTransactionData(BookId.BookId, "R");
                    setAllDisUnable(false);
                } else {
                    toast.info(bookingResponse.data.Message);
                }
            }
            handleAccountGenerateClick();
        } catch (error) {
            toast.error("Error processing request");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCalulate = () => {
        let TotAmt = (((watch("BedRent") * watch('Duration') / 100)) * watch("IncRentPerc"));
        setValue("TotalRent", ((watch("BedRent") * watch('Duration')) + TotAmt));
        let MonthlyAMt = Math.round((watch("TotalRent") / watch("Duration")));
        setValue("MonthlyAmt", MonthlyAMt);
        setValue("NetAmt", watch("TotalRent"))
        let totalPayable = (parseInt(watch("NetAmt")) - (parseFloat(watch("FreeMonth")) * MonthlyAMt));
        let NetPayable = totalPayable - watch("DiscAmt")
        setValue("AdvcRcble", Math.round(NetPayable));
        setTmt();
    };

    const setTmt = () => {
        setValue("TotNetAmt", ((parseInt(watch("AdvcRcble")) || 0) + (parseInt(watch("TrspChrg")) || 0) + (parseInt(watch("MessChrg")) || 0)));
        let amtInWord = numToChar(watch("TotNetAmt"));
        setValue("AmtInWor", amtInWord.concat(" Only/-"));
    };

    const fetchTopUpData = async (RTypeId, ByFlag) => {
        try {
            const response = await axiosInstance.post(`MstTopup/getMstTopupdrp`,
                {
                    "RoomTypeId": RTypeId,
                    "Flag": "",
                    "PropId": watch("PropId"),
                },

            );
            if (response.data.Status === 0) {
                setTopUpDrp(response.data.Data);
                if (ByFlag === "button") {
                    setValue("TopupId", response.data.Data[0].TopupID || 1);
                    setValue("TopupAmt", response.data.Data[0].TopupAmt || 0);
                }
            } else {
                // toast.info('Error fetching TopUpData data');
                setTopUpDrp([]);
            }
        } catch (error) {
            // toast.error('Error fetching TopUpData data');
        }
    };

    const handlePlanChange = (value) => {
        setValue("RoomPlanId", value);
        let obj = PlanDrp.find(plan => plan.RoomPlanID === value);
        if (obj) {
            const { PlanTenur, FreeMonth, LastAdjMonths, IncRentPerc, TotalInstall, DepositAmt, PlanName } = obj;
            let setObj = { PlanTenur, FreeMonth, LastAdjMonths, IncRentPerc, TotalInstall, DepositAmt, PlanName };

            for (let key in setObj) {
                setValue(key, setObj[key]);
            }

            handleCalulate();
        }
    };

    const handlePrevClick = () => {
        fetchTransactionData(BookId, "P");
    }

    const handleNextClick = () => {
        fetchTransactionData(BookId, "N");
    }

    const handleAddClick = () => {
        setMode("add");
        setAllDisUnable(true);
        setIsSubmitting(false);
        setHistoryData([]);
        resetFunc();
        if (PropertyDrp.length > 0) {
            // setValue("PropId", PropertyDrp[0]?.Id);
            fetchPlanDrpData();
        }
    }

    const handleEditClick = async () => {
        setIsSubmitting(false);
        setAllDisUnable(true)
        setMode('edit')
        // if (TransactionData[0]?.BookSt === "B") {

        //     let Flag = await checkAndLock(BookId, "TrnBooking", "BookId");
        //     console.log('flag',Flag);
        //     switch (Flag) {
        //         case 0:
        //             setMode("edit");
        //             setAllDisUnable(false);
        //             break;
        //         case 1:
        //             toast.info("Record  Already Locked", { autoClose: 500 });
        //             break;
        //         case 2:
        //             toast.info("Record Failed To Locked", { autoClose: 500 });
        //             break;
        //         default:
        //             toast.info("Something Went Wrong", { autoClose: 500 });
        //     }

        // } 
    };

    const handleDeleteClick = () => {
        if (TransactionData[0]?.BookSt === "B") {
            setOpenDForDelete(true);
        } else {
            toast.info("Cannot Delete Confirm Record!");
        }
    }

    const handleClickBackToTable = () => {
        navigate('/BookingConfirmTable')
    }

    const handleCancelClick = async () => {
        setAllDisUnable(prev => !prev);
        if (BookId === -1 && Mode === "add") {
            await fetchTransactionData(1, "L")
        } else {
            const idToPass = typeof BookId === 'object' ? BookId.BookId : BookId;
            await UnLock(BookId.BookId, "TrnBooking", "BookId");
            await fetchTransactionData(idToPass, "R");
        }
    }

    const handleConfirmDelete = async () => {
        navigate(`/resident`, { state: { IsFromTransaction: true, Mobile: watch('MobileNo') } })
    }

    const handleBookingHistoryClick = () => {
        setOpenHistoryTableDialog1(true);
    }

    const handleClickCancelBooking = () => {
        if (BookId != -1 && Mode == "view" && TransactionData[0].BookSt != 'C') {
            setOpenDForCancel(true);
        } else if (TransactionData[0].BookSt == 'C') {
            toast.info("Cannot Cancel The Confirm Record!!");
        } else {
            toast.info("Not An Valid Transaction To Cancel");
        }
    }

    const handleCancelBooking = async () => {

        let Flag = "";
        if (TransactionData[0].BookSt === "B") {
            Flag = "X";
        } else if (TransactionData[0].BookSt === "X") {
            Flag = "B";
        }

        try {
            const response = await axiosInstance.post(`TrnBooking/TrnBookingConfirmation`, {
                "BookId": TransactionData[0].BookId,
                "CreatedBy": UserId,
                "Flag": Flag
            });

            if (response.data.Status === 0) {
                toast.success(response.data.Message);
                await fetchTransactionData(BookId, "R");
            } else {
                toast.error(response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching company data:', error);
        }
    }

    const handleClose = () => {
        setOpenHistoryTableDialog(false);
        setPage(0);
        setTimeout(() => {
            setSearchTerms({});
        }, [500]);

    };

    const handleCancelDButton = () => {
        setOpenDForDelete(false);
    }

    const handleCancelCButton = () => {
        setOpenDForCancel(false);
    }

    const handleConfirmDDelete = () => {
        if (BookId != -1 && Mode == "view") {
            fetchTransactionData(BookId, "D");
        }
        setOpenDForDelete(false);
    }

    const handleConfirmCancel = () => {
        if (BookId != -1 && Mode == "view" && TransactionData[0].BookSt != 'C') {
            handleCancelBooking()
        }
        setOpenDForCancel(false);
    }

    const handleTopUpChange = (e) => {
        setValue(e.target.name, e.target.value);
        let Amt = 0;
        if (e.target.name === "TopupId") {
            let getObj = TopUpDrp.find(obj => obj.TopupID === e.target.value);
            if (getObj) {
                setValue("TopupAmt", getObj.TopupAmt || 0);
                setValue("Topupdays", getObj.Topupdays || 0);
                Amt = getObj.TopupAmt;
            }
        } else if (e.target.name === "TransPlanId") {
            let getObj = TransPlanDrp.find(obj => obj.TransPlanID === e.target.value);
            if (getObj) {
                setValue("TrspChrg", getObj.Amount);
                setValue("TransPlanId", getObj.TransPlanID);
                Amt = getObj.Amount;
            }
        } else if (e.target.name === "MessPlanId") {
            let getObj = MessPlanDrp.find(obj => obj.MessPlanID === e.target.value);
            if (getObj) {
                setValue("MessChrg", getObj.Amount);
                setValue("MessPlanId", getObj.MessPlanID);
                Amt = getObj.Amount;
            }
        }
        setTmt();
        // setValue("Tamt",(Amt+watch("Tamt")));
    }

    const handleEmailSentLink = async () => {
        setOpenLoader(true);
        const propId = parseInt(watch("PropId"));
        const userId = parseInt(UserId);
        const baseUrl = window.location.origin;

        const propertyData = PropertyDrp?.find(p => p.Id === propId);
        const gatewayType = propertyData?.GateWay_Type || gatewayType || 'CashFree';
        let paymentResponse = null;

        try {

            if (gatewayType === 'CashFree') {
                const paymentDetails = {
                    customer_details: {
                        customer_email: watch("Email"),
                        customer_name: watch("FirstName"),
                        customer_phone: watch("MobileNo")
                    },
                    link_amount: parseFloat(watch("DepositAmt")) || 0,
                    link_auto_reminders: true,
                    link_currency: "INR",
                    link_expiry_time: "2026-06-09T15:04:05+05:30",
                    link_id: "Testing9062026",
                    link_meta: {
                        notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                        return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                        upi_intent: false
                    },
                    link_minimum_partial_amount: parseFloat(watch("DepositAmt")),
                    link_notes: {
                        key_1: "CashFreepay",
                        key_2: "linkCashfree"
                    },
                    link_notify: {
                        send_email: false,
                        send_sms: true
                    },
                    link_partial_payments: false,
                    link_purpose: "Booking Advance",
                    ResidentId: ResidentId,
                    Flag: "Active",
                    Remark: "Testing",
                    TrjType: "TrnPytAdv",
                    TrjDocNo: watch("BookNo"),
                    TrjDocId: BookId,
                    cf_payment_id: "",
                    payment_status: "",
                    PropId: propId,
                };

                const response = await axiosInstanceForPG.post(
                    `PaymentGatewayLog/CreateCashFreeLink`,
                    paymentDetails,
                );

                if (response.data.Status == 0) {
                    handleLoaderClose();
                    return toast.success(response.data.Message);
                }

                paymentResponse = response.data;
                if (typeof paymentResponse === 'string') {
                    paymentResponse = JSON.parse(paymentResponse);
                }

                if (paymentResponse.Status === 0 && paymentResponse.Message === "Payment Link Already Sent!") {
                    const existingPaymentLink = paymentResponse.Data;
                    console.log("Existing Payment Link:", existingPaymentLink);
                    const Subject = `Payment Link for Booking [${watch("BookNo")}]  `;
                    const Body = `Dear ${watch("FirstName")} ${watch("LastName")},<br>
                    Please find the secure payment link for your recent transaction below <br><br>
                    Payment Link: ${existingPaymentLink}<br>
                    Ref- Payment Advice No :- [${watch("PytAdvNo")}]<br>
                    Kindly make the payment of Deposit Amount [${watch("DepositAmt")}] . If you have any questions, feel free to reach out.<br><br>
                    Thank you for your prompt attention.<br><br>
                    Best regards,<br>
                    Clanbridge Living Pvt Ltd.`;

                    const emailRequest = {
                        ToEmail: watch("Email") ? [watch("Email")] : [],
                        Subject,
                        Body,
                        Attachments: '',
                        attachmentFilePaths: [],
                        PropId: propId,
                        UserId: userId,
                    };

                    const emailResponse = await axiosInstanceForPG.post(
                        `EmailRequest/SendEmail`,
                        emailRequest,
                    );
                    if (emailResponse.data.Status === 0) {
                        toast.success("Payment Link Already Sent.!");
                    } else {
                        toast.info(emailResponse.data.Message);
                    }
                    handleLoaderClose();
                    return;
                }

                if (!paymentResponse || !paymentResponse.link_url) {
                    console.error("Invalid payment response:", paymentResponse);
                    toast.error("Failed to create payment link");
                    handleLoaderClose();
                    return;
                }

            } else if (gatewayType === 'Instamojo') {
                const paymentDetails = {
                    purpose: "Booking Advance",
                    amount: parseFloat(watch("DepositAmt")) || 0,
                    buyer_name: watch("FirstName") || '',
                    email: watch("Email") || '',
                    phone: watch("MobileNo") || '',
                    redirect_url: `${baseUrl}/payment-success`,
                    redirecturl: `${baseUrl}/payment-success/`,
                    webhook_url: '',
                    ResidentId: ResidentId,
                    TrjDocId: watch("PytAdvId") || 0,
                    TrjType: "TrnPytAdv",
                    TrjDocNo: watch("PytAdvNo") || '',
                    PropId: propId || 0,
                };

                const response = await axiosInstanceForPG.post(
                    `Payment/CreatePaymentOrder`,
                    paymentDetails,
                );

                if (response.data.Status == 0) {
                    handleLoaderClose();
                    return toast.success(response.data.Message);
                }

                paymentResponse = JSON.parse(response.data);

                if (paymentResponse.Status === 0 && paymentResponse.Message === "Payment Link Already Sent!") {
                    const existingPaymentLink = paymentResponse.Data;
                    const Subject = `Payment Link for Booking [${watch("BookNo")}]  `;
                    const Body = `Dear ${watch("FirstName")} ${watch("LastName")},<br>
                    Please find the secure payment link for your recent transaction below <br><br>
                    Payment Link: ${existingPaymentLink}<br>
                    Ref- Payment Advice No :- [${watch("PytAdvNo")}]<br>
                    Kindly make the payment of Deposit Amount [${watch("DepositAmt")}] . If you have any questions, feel free to reach out.<br><br>
                    Thank you for your prompt attention.<br><br>
                    Best regards,<br>
                    Clanbridge Living Pvt Ltd.`;

                    const emailRequest = {
                        ToEmail: watch("Email") ? [watch("Email")] : [],
                        Subject,
                        Body,
                        Attachments: '',
                        attachmentFilePaths: [],
                        PropId: propId,
                        UserId: userId,
                    };

                    const emailResponse = await axiosInstanceForPG.post(
                        `EmailRequest/SendEmail`,
                        emailRequest,
                    );
                    if (emailResponse.data.Status === 0) {
                        toast.success("Payment Link Already Sent.!");
                    } else {
                        toast.info(emailResponse.data.Message);
                    }
                    handleLoaderClose();
                    return;
                }

                if (!paymentResponse || !paymentResponse.payment_request || !paymentResponse.payment_request.longurl) {
                    toast.error("Failed to create payment link");
                    handleLoaderClose();
                    return;
                }

            } else {
                toast.error(`Unsupported gateway type: ${gatewayType}`);
                handleLoaderClose();
                return;
            }


            const paymentToken = gatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
            const paymentUrl = gatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl;
            const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;

            let paymentLogPayload;
            if (gatewayType === 'CashFree') {
                paymentLogPayload = {
                    id: paymentResponse.link_id,
                    cf_link_id: paymentResponse.cf_link_id,
                    phone: paymentResponse.customer_details.customer_phone,
                    email: paymentResponse.customer_details.customer_email,
                    buyer_name: paymentResponse.customer_details.customer_name || 'null',
                    amount: paymentResponse.link_amount,
                    purpose: paymentResponse.link_purpose,
                    expires_at: null,
                    status: paymentResponse.link_status,
                    send_sms: paymentResponse.link_notify.send_sms,
                    send_email: paymentResponse.link_notify.send_email,
                    sms_status: 'null',
                    email_status: 'null',
                    shorturl: 'null',
                    longurl: paymentResponse.link_url,
                    redirect_url: paymentResponse.link_meta.return_url,
                    webhook: 'null',
                    allow_repeated_payments: true,
                    created_at: paymentResponse.link_created_at,
                    modified_at: paymentResponse.link_created_at,
                    ResidentId: ResidentId,
                    link_qrcode: paymentResponse.link_qrcode,
                    TrjDocNo: watch("PytAdvNo"),
                    TrjDocId: watch("PytAdvId"),
                    TrjType: "TrnPytAdv",
                    Flag: "Active",
                    Remark: "Testing",
                    Gatewaytype: "CashFree",
                };
            } else {
                paymentLogPayload = {
                    id: paymentResponse.payment_request.id,
                    phone: paymentResponse.payment_request.phone,
                    email: paymentResponse.payment_request.email,
                    buyer_name: paymentResponse.payment_request.buyer_name,
                    amount: paymentResponse.payment_request.amount,
                    purpose: paymentResponse.payment_request.purpose,
                    expires_at: paymentResponse.payment_request.expires_at,
                    status: paymentResponse.payment_request.status,
                    send_sms: paymentResponse.payment_request.send_sms,
                    send_email: paymentResponse.payment_request.send_email,
                    sms_status: paymentResponse.payment_request.sms_status,
                    email_status: paymentResponse.payment_request.email_status,
                    shorturl: paymentResponse.payment_request.shorturl,
                    longurl: paymentResponse.payment_request.longurl,
                    redirect_url: paymentResponse.payment_request.redirect_url,
                    webhook: paymentResponse.payment_request.webhook,
                    allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
                    created_at: paymentResponse.payment_request.created_at,
                    modified_at: paymentResponse.payment_request.modified_at,
                    ResidentId: ResidentId,
                    TrjDocNo: watch("PytAdvNo"),
                    TrjDocId: watch("PytAdvId"),
                    TrjType: "TrnPytAdv",
                    Flag: "Active",
                    Remark: "Testing",
                    Gatewaytype: "Instamojo",
                };
            }

            await axiosInstance.post(
                'PaymentGatewayLog/InsertPaymentRequestLog',
                paymentLogPayload
            );

            const Subject = `Payment Link for Booking [${watch("BookNo")}]  `;
            const Body = `Dear ${watch("FirstName")} ${watch("LastName")},<br>
            Please find the secure payment link for your recent transaction below <br><br>                     
            Payment Link: ${intermediatePageUrl}<br>
            Ref- Payment Advice No :- [${watch("PytAdvNo")}] <br>
            Kindly make the payment of Amount [${watch("DepositAmt")}] . If you have any questions, feel free to reach out.<br><br>
            Thank you for your prompt attention.<br><br>
            Best regards,<br>
            Clanbridge Living Pvt Ltd.`;

            const emailRequest = {
                ToEmail: watch("Email") ? [watch("Email")] : [],
                Subject,
                Body,
                Attachments: '',
                attachmentFilePaths: [],
                PropId: propId,
                UserId: userId,
            };

            const emailResponse = await axiosInstanceForPG.post(
                `EmailRequest/SendEmail`,
                emailRequest,
            );

            if (emailResponse.data.Status === 0) {
                toast.success("Payment Link Sent Successfully");
            } else {
                toast.info(emailResponse.data.Message);
            }

        } catch (error) {
            if (error.response) {
                toast.error(`Error: ${error.response.data.Message || 'Unknown error'}`);
            } else if (error.request) {
                toast.error('No response from the server');
            } else {
                toast.error("Error processing payment request");
            }
        } finally {
            handleLoaderClose();
        }
    };

    const numToChar = (num) => {
        if (num === 0) return 'Zero';

        const belowTwenty = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const aboveHundred = ['Hundred', 'Thousand', 'Lakh', 'Crore'];

        const startConvert = (n) => {
            let res = '';

            if (n >= 10000000) {
                res += startConvert(Math.floor(n / 10000000)) + ' Crore ';
                n %= 10000000;
            }
            if (n >= 100000) {
                res += startConvert(Math.floor(n / 100000)) + ' Lakh ';
                n %= 100000;
            }
            if (n >= 1000) {
                res += startConvert(Math.floor(n / 1000)) + ' Thousand ';
                n %= 1000;
            }
            if (n >= 100) {
                res += startConvert(Math.floor(n / 100)) + ' Hundred ';
                n %= 100;
            }
            if (n >= 20) {
                res += tens[Math.floor(n / 10) - 2] + ' ';
                n %= 10;
            }
            if (n > 0) {
                res += belowTwenty[n] + ' ';
            }

            return res.trim();
        };

        const integerPart = Math.floor(num);
        const decimalPart = Math.round((num - integerPart) * 100);

        let result = startConvert(integerPart);
        if (decimalPart > 0) {
            result += ' and ' + startConvert(decimalPart) + ' Paise';
        }

        return result.trim();
    };

    const handleLoaderClose = () => {
        setOpenLoader(false);
    }

    const handleBillingDetails = async () => {

        if (BookId === -1) {
            toast.info("No transaction is visible");
            return;
        }

        try {
            setOpenLoader(true); // Show loader while fetching
            const response = await axiosInstance.post(
                'TrnBooking/GetReportTrnBooking',
                {
                    "BookId": BookId, // original was "BookId": BookId.BookId,
                    "Flag": "R"
                }
            );
            if (response.data.Status === 0 && response.data.Data) {
                setBillingDetails(response.data.Data);
                setOpenBillingModal(true);
                await fetchPlanDataState(TransactionData[0].RoomPlanId);
                await fetchPayAdvice(BookId);
                await fetchPayGenerate(BookId);
                await fetchPendingDetails(BookId);
                await fetchSummaryReport(BookId);
                await fetchReceiptReport(BookId);
            } else {
                toast.error('No billing details found');
            }
        } catch (error) {
            toast.error('Error fetching billing details');
        } finally {
            setOpenLoader(false); // Hide loader
        }
    };

    const fetchPlanDataState = async (PlanId) => {
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
                "RoomPlanID": PlanId,
                "Flag": "R"
            });

            if (response.data.Status === 0) {
                setPlanDataState(response.data.Data);
                setOpenBillingModal(true);
            }
        } catch (error) {
            console.error('Error fetching plan data:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchPayAdvice = async (BookId) => {
        try {
            setOpenLoader(true);
            const currentDate = dayjs().format('YYYY-MM-DD');
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                PytAdvDt: currentDate,
                Flag: "BookingWise",
                BookId: BookId  // Original -- "BookId": BookId.BookId
            });

            if (response.data.Status === 0) {
                setPayAdvice(response.data.Data);
                setOpenBillingModal(true);
            }
        } catch (error) {
            toast.error('Error fetching plan data:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchPayGenerate = async (Id) => {
        try {
            setOpenLoader(true);
            const currentDate = dayjs().format('YYYY-MM-DD');
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                PytAdvDt: currentDate,
                Flag: "GenPytAdv",
                BookId: BookId // Original --- "BookId": Id.BookId
            });

            if (response.data.Status === 0) {
                setPayGenerate(response.data.Data);
                setOpenBillingModal(true);
            }
        } catch (error) {
            toast.error('Error fetching pay generate data:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchSummaryReport = async (Id) => {
        try {
            setOpenLoader(true);
            const currentDate = dayjs().format('YYYY-MM-DD');
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                PytAdvDt: currentDate,
                Flag: "GenAccSum",
                BookId: Id
            });

            if (response.data.Status === 0) {
                setSummaryReport(response.data.Data);
                setOpenBillingModal(true);
            }
        } catch (error) {
            console.error('Error fetching pay generate data:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchReceiptReport = async (Id) => {
        try {
            setOpenLoader(true);
            const currentDate = dayjs().format('YYYY-MM-DD');
            const response = await axiosInstance.post('BookingReports/GetBookingReportsDetail', {
                BookDtFrom: currentDate,
                BookUpToDt: currentDate,
                PropId: "88",
                Flag: "PyAdvWiseRecVchr",
                Id: Id
            });
            if (response.data.Status === 0) {
                setReceiptSummary(response.data.Data);
                setOpenBillingModal(true);
            }
        } catch (error) {
            toast.error('Error While fetching the receipt summary.');
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchPendingDetails = async (pendingId) => {
        try {
            setOpenLoader(true);
            const currentDate = dayjs().format('YYYY-MM-DD')
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                Flag: "UnBilledAdvPyt",
                BookId: BookId,
                PytAdvDt: currentDate
            });

            if (response.data.Status === 0) {
                setPendingDetails(response.data.Data);
                setOpenBillingModal(true);
            } else {
                console.info(response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching pending details data:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const handleAccountGenerateClick = async () => {
        if (!watch('RoombedName') || watch('RoombedName') === '') {
            toast.error("Please select a Bed No before generating account");
            return;
        }
        if (BookId === -1) {
            toast.info("Transaction is Not Visible!!");

            return;
        }

        setOpenLoader(true);

        try {
            const response = await axiosInstance.post(`TrnBooking/AccountGenerateTrnBooking`,
                {
                    "BookId": BookId,  // original was "BookId": BookId.BookId,
                    "CreatedBy": UserId,
                    "AccountGenerate": "1",
                    "IsAccGen": "",
                    "IsDepPaid": isDepositPaid
                }
            );

            if (response.data.Status === 0) {
                try {
                    const dataResponse = await axiosInstance.post(`BedCalendar/GetTrnBookingDtlwise`, {
                        "Flag": "",
                        "BookId": BookId   // original was "BookId": BookId.BookId,
                    });

                    if (dataResponse.data.Status === 0) {
                        const formattedData = dataResponse.data.Data.map(obj => {
                            return { ...obj, PyadDt: moment(obj.PyadDt).format("MM-DD-YYYY") }
                        });
                        sessionStorage.setItem('accountGenerateData', JSON.stringify(formattedData));
                        navigate(`/accgeneratetable`, {
                            state: {
                                accountData: formattedData,
                                bookingInfo: {
                                    residentName: watch("ResidentName"),
                                    bookNo: watch("BookNo"),
                                    mobileNo: watch("MobileNo")
                                }
                            }
                        });
                    } else {
                        toast.error(dataResponse.data.Message || 'Error fetching account data');
                    }
                } catch (error) {
                    toast.error('Error fetching account data');
                }
            } else {
                toast.info(response.data.Message || 'Error in account generation');
            }
        } catch (error) {
            toast.error('Error in account generation');
        } finally {
            setOpenLoader(false);
        }
    };

    const ToRenewnavigation = () => {
        navigate('/renewbooking', {
            state: {
                BookId: BookId,
                residentData: watch(),
                selectedBedData: selectedBedData
            }
        });
    }
    const CancelConfirmation = () => {
        if (UtType === "Admin") {
            setOpenOtpDialog(true);
        } else {
            toast.error("You are not an authorized person");
        }
    }
    const handleBookNoChange = async (e, Separator) => {
        let val = "";
        if (Separator === "A") {
            val = e.target.value.trim()
        } else {
            val = e.trim();
        }

        if (val.length >= 8) {
            try {
                const response = await axiosInstance.post(`TrnBooking/GetTrnBookingDashBoard`,
                    {
                        "start": 1,
                        "PageSize": 1,
                        "SearchText": '',
                        "Flag": '',
                        "MobileNo": '',
                        "BookNo": val,
                        "PropId": 1,
                    }
                );

                if (response.data.Status === 0 && response.data.Data.length > 0) {
                    const bookingData = response.data.Data[0];
                    setValue("BookNo", bookingData.BookNo);
                    setValue("BookDt", bookingData.BookDt);
                    setValue("BookDtFrom", bookingData.BookDtFrom);
                    setValue("BookUpToDt", bookingData.BookUpToDt);
                    setValue("CheckoutDt", bookingData.CheckoutDt);
                    setValue("Duration", bookingData.Duration);
                    setValue("BookRef", bookingData.BookRef);
                    setValue("BookRemark", bookingData.BookRemark);
                    setValue("BillCycle", bookingData.BillCycle);
                    setValue("MobileNo", bookingData.MobileNo);
                    setValue("FirstName", bookingData.FirstName);
                    setValue("LastName", bookingData.LastName);
                    setValue("Email", bookingData.Email);
                    setValue("ResidentName", bookingData.ResidentName);
                    setResidentId(bookingData.ResidentId);
                    setValue("PropId", bookingData.PropId);
                    setValue("RoomPlanId", bookingData.RoomPlanId);
                    setValue("PlanName", bookingData.PlanName);
                    setValue("RoomTypeName", bookingData.RoomTypeName);
                    setValue("RoomViewNAme", bookingData.RoomViewName || "");
                    setValue("RoomBedTypeName", bookingData.RoomBedTypeName || "");
                    setValue("RoombedName", bookingData.RoombedName);
                    setValue("BedRent", bookingData.BedRent);
                    setValue('RoomBedId', bookingData.RoomBedId);
                    setValue("PlanTenur", bookingData.PlanTenur || 0);
                    setValue("FreeMonth", bookingData.FreeMonth || 0);
                    setValue("LastAdjMonths", bookingData.LastAdjMonths || 0);
                    setValue("IncRentPerc", bookingData.IncRentPerc || 0);
                    setValue("DepositAmt", bookingData.DepositAmt || 0);
                    setValue("CouponNo", bookingData.CouponNo || "");
                    setValue("DiscType", bookingData.DiscType || "");
                    setValue("DiscAmt", bookingData.DiscAmt || 0);
                    setValue("TotalRent", bookingData.TotalRent || 0);
                    setValue("NetAmt", bookingData.NetAmt || 0);
                    setValue("MonthlyAmt", bookingData.MonthlyAmt || 0);
                    setValue("AdvcRcble", bookingData.AdvcRcble || 0);
                    setValue("TopupId", bookingData.TopupId || 0);
                    setValue("Topupdays", bookingData.Topupdays || 0);
                    setValue("TopupAmt", bookingData.TopupAmt || 0);
                    setValue("TransPlanId", bookingData.TransPlanId || 1);
                    setValue("TrspChrg", bookingData.TrspChrg || 0);
                    setValue("MessPlanId", bookingData.MessPlanId || 1);
                    setValue("MessChrg", bookingData.MessChrg || 0);
                    setValue("TotNetAmt", bookingData.TotNetAmt || 0);
                    setValue("AmtInWor", numToChar(bookingData.TotNetAmt || 0).concat(" Only/-"));
                    setValue("BookStatus", bookingData.BookStatus);
                    const apiBookingType = bookingData.BookingType === "R" ? "renewal" : "new";
                    setValue("bookingType", apiBookingType);
                    setValue("RoomTypeId", bookingData.RoomTypeId);
                    setValue("RoomViewId", bookingData.RoomViewId);
                    setValue("RoomBedTypeId", bookingData.RoomBedTypeId);
                    setValue("BedCatId", bookingData.BedCatId);
                    setIsDepositPaid(bookingData.IsDepPaid === "Y");
                    setIsBookingConfirmed(bookingData.BookSt === "C");
                    setRegenerate(bookingData.IsAccGen === "G");
                    setTransactionData(response.data.Data);
                    setBookId(bookingData.BookId);
                    setLastId(bookingData.LastBookId);
                    setOldBedId(bookingData.RoomBedId);
                    // setMode("view");
                    // setAllDisUnable(false);

                    await fetchPlanDrpData(bookingData.PropId);
                    await fetchTopUpData(bookingData.RoomTypeId, "view");
                    await fetchHistoryData(bookingData.ResidentId);
                } else {
                    toast.info("Booking Doesn't Exist On This Number");
                    setValue("MobileNo", "");
                    setBookId(-1);
                }
            } catch (error) {
                toast.error('Error fetching booking details');
            }
        } else if (val.length === 7) {
            setValue("MobileNo", "");
            setBookId(-1);
        }
        Separator === "B" && handleClose();
    }

    const handleMobileChange = async (e, ByFlag, value = null) => {
        const newPhone = value !== null ? value : e.target?.value?.trim();

        setValue('MobileNo', newPhone);

        if (newPhone && newPhone.length === MobDigit) {
            setMobileNo(newPhone);

            try {
                const response = await axiosInstance.post(`TrnBooking/GetTrnBookingDashBoard`, {
                    "start": 1,
                    "PageSize": 1,
                    "SearchText": '',
                    "Flag": '',
                    "MobileNo": newPhone,
                    "BookNo": '',
                    "PropId": 1,
                });

                if (response.data.Status === 0 && response.data.Data[0]) {
                    const bookingData = response.data.Data[0];
                    setValue("BookNo", bookingData.BookNo);
                    setValue("BookDt", bookingData.BookDt);
                    setValue("BookDtFrom", bookingData.BookDtFrom);
                    setValue("BookUpToDt", bookingData.BookUpToDt);
                    setValue("CheckoutDt", bookingData.CheckoutDt);
                    setValue("Duration", bookingData.Duration);
                    setValue("BookRef", bookingData.BookRef);
                    setValue("BookRemark", bookingData.BookRemark);
                    setValue("BillCycle", bookingData.BillCycle);
                    setValue("FirstName", bookingData.FirstName);
                    setValue("LastName", bookingData.LastName);
                    setValue("Email", bookingData.Email);
                    setValue("ResidentName", bookingData.ResidentName);
                    setResidentId(bookingData.ResidentId);
                    setValue("PlanTenur", bookingData.PlanTenur || 0);
                    setValue("FreeMonth", bookingData.FreeMonth || 0);
                    setValue("LastAdjMonths", bookingData.LastAdjMonths || 0);
                    setValue("IncRentPerc", bookingData.IncRentPerc || 0);
                    setValue("DepositAmt", bookingData.DepositAmt || 0);
                    setValue("CouponNo", bookingData.CouponNo || "");
                    setValue("DiscType", bookingData.DiscType || "");
                    setValue("DiscAmt", bookingData.DiscAmt || 0);
                    setValue("TotalRent", bookingData.TotalRent || 0);
                    setValue("NetAmt", bookingData.NetAmt || 0);
                    setValue("MonthlyAmt", bookingData.MonthlyAmt || 0);
                    setValue("AdvcRcble", bookingData.AdvcRcble || 0);
                    setValue("TopupId", bookingData.TopupId || 0);
                    setValue("Topupdays", bookingData.Topupdays || 0);
                    setValue("TopupAmt", bookingData.TopupAmt || 0);
                    setValue("TransPlanId", bookingData.TransPlanId || 1);
                    setValue("TrspChrg", bookingData.TrspChrg || 0);
                    setValue("MessPlanId", bookingData.MessPlanId || 1);
                    setValue("MessChrg", bookingData.MessChrg || 0);
                    setValue("TotNetAmt", bookingData.TotNetAmt || 0);
                    setValue("PropId", bookingData.PropId);
                    setValue("RoomPlanId", bookingData.RoomPlanId);
                    setValue("PlanName", bookingData.PlanName);
                    setValue("RoomTypeName", bookingData.RoomTypeName);
                    setValue("RoomViewNAme", bookingData.RoomViewName || "");
                    setValue("RoomBedTypeName", bookingData.RoomBedTypeName || "");
                    setValue("RoombedName", bookingData.RoombedName);
                    setValue("BedRent", bookingData.BedRent);
                    setValue("BookId", bookingData.BookId)
                    setValue("BookSt", bookingData.BookSt)
                    setValue('RoomBedId', bookingData.RoomBedId);
                    //  setValue('RoomBedId', bookingData.RoomBedId);
                    setValue("CheckinDt", bookingData.CheckinDt)
                    await fetchPlanDrpData(bookingData.PropId);
                    await fetchTopUpData(bookingData.RoomTypeId, "view");
                    await fetchHistoryData(bookingData.ResidentId);
                    if (bookingData.CouponNo) {
                        setValue("CouponNo", bookingData.CouponNo);
                        setValue("DiscType", bookingData.DiscType);
                        setValue("DiscountAmt", bookingData.DiscountAmt || 0);
                        setValue("DiscAmt", bookingData.DiscAmt || 0);
                        setValue("AMTDISCOUNT", bookingData.DiscAmt || 0);
                    } else {
                        setValue("CouponNo", "");
                        setValue("DiscType", "");
                        setValue("DiscountAmt", 0);
                        setValue("DiscAmt", 0);
                        setValue("AMTDISCOUNT", 0);
                    }
                    fetchHistoryData(bookingData.ResidentId);
                } else {
                    setopenConfirmDialog(true);
                }
            } catch (error) {
                toast.error('Error fetching resident data');
            }
        } else {
            setValue("FirstName", "");
            setValue("LastName", "");
            setValue("Email", "");
            setValue("ResidentName", "");
            setValue("CouponNo", "");
            setValue("DiscType", "");
            setValue("DiscountAmt", 0);
            setValue("DiscAmt", 0);
            setValue("AMTDISCOUNT", 0);
            setResidentId(-1);
            setHistoryData([]);
        }
    }

    const handleClickCheckAvaCal = () => {
        const startDate = dayjs(watch('CheckinDt'));
        const endDate = dayjs(watch('BookUpToDt'));
        setDateFrom(startDate);
        setDateTo(endDate);
        setOpenHistoryTable(true);
    }

    const handleRowDoubleClick = async (row) => {
        const {
            WingName,
            FloorName,
            RoomTypeName,
            RoomViewNAme,
            RoomBedTypeName,
            RoombedName,
            BedRent,
            RoomBedId,
            RoomTypeId,
            RoomViewId,
            RoomBedTypeId,
            BedCatId,
            RoomId,
        } = row;
        setValue("WingName", WingName || "");
        setValue("FloorName", FloorName || "");
        setValue("RoomTypeName", RoomTypeName || "");
        setValue("RoomViewNAme", RoomViewNAme || "");
        setValue("RoomBedTypeName", RoomBedTypeName || "");
        setValue("RoombedName", RoombedName || "");
        setValue("BedRent", BedRent);
        setValue("RoomTypeId", RoomTypeId);
        setValue("RoomViewId", RoomViewId);
        setValue("RoomBedTypeId", RoomBedTypeId);
        setValue("BedCatId", BedCatId);
        setValue('RoomBedId', RoomBedId)
        setValue('RoomId', RoomId)

        setSelectedBedData(row);

        setOpenHistoryTable(false);

        if (BookId !== -1) {
            try {
                setOpenLoader(true);
                const response = await axiosInstance.post('BedCalendar/GetPropWiseBedCalendarMonthRoomBed', {
                    RoomBedId: RoomBedId,
                    PropId: watch('PropId'),
                    BookDtFrom: DateFrom.format('YYYY-MM-DD'),
                    CheckoutDt: DateTo.format('YYYY-MM-DD'),
                    Flag: "",
                    BedCatId: BedCatId,
                    OldRoomBedId: oldBedId
                });

                if (response.data.Status === 0) {
                    toast.error(response.data.Message);
                    // Refresh the booking data
                    await fetchTransactionData(BookId, "R");
                } else {
                    // toast.error(response.data.Message || "Failed to change room");
                }
            } catch (error) {
                toast.error("Error changing room");
            } finally {
                setOpenLoader(false);
            }
        }
    };

    const handleCloseRoom = () => {
        setOpenHistoryTable(false)
    }

    const handleRefresh = async () => {
        try {
            const payload = {
                PropId: watch('PropId'),
                Flag: ''
            };

            await Promise.all([
                axiosInstance.post('BedCalendar/InsertBedCat', payload),
                axiosInstance.post('BedCalendar/InsertBedCatCal', payload),
                axiosInstance.post('BedCalendar/UpdateBedCat', payload),
                axiosInstance.post('BedCalendar/UpdateBedCatCal_Data', payload),
            ]);
            toast.success("Latest data retrieved successfully.");
            await fetchCategoryData('');
        } catch (error) {
            toast.error("Error while fetching the data.")
        }
    };

    const selectedMessPlanId = watch('MessPlanId');
    const selectedMessPlan = MessPlanDrp.find(item => item.MessPlanID === selectedMessPlanId);

    const selectedTransPlanId = watch('TransPlanId');
    const selectedTransPlan = TransPlanDrp.find(item => item.TransPlanID === selectedTransPlanId);

    const handleConfirmCancellation = async () => {
        try {
            const paylod = {
                BookId: BookId,
                CancelBy: UserId,
                "CreatedDate": new Date().toISOString().split('T')[0],
                "Flag": "B"
            }
            const response = await axiosInstance.post('TrnBooking/TrnBookingConfirmation', paylod)
            if (response.data.Status === 0) {
                toast.success('Your Booking Status has been Changed successfully');
                await fetchTransactionData(BookId, "R");
                setInputValue("");
                setOpenOtpDialog(false);
            }

        } catch (error) {
            toast.error("Error while cancelling the transaction.");
        }
    }
    const defaultCode = "55555";
    const handleCancelCancellation = () => {
        setOpenOtpDialog(false);
        setInputValue("");
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box className="form-container">
                <Backdrop
                    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                    open={OpenLoader}
                    onClick={handleLoaderClose}
                >
                    <CircularProgress color="inherit" />
                    Please Wait .....
                </Backdrop>
                <ToastContainer />


                <BookingHistory OpenHistoryTableDialog1={OpenHistoryTableDialog1} setOpenHistoryTableDialog1={setOpenHistoryTableDialog1} rows={HistoryData} />
                <BillingDetailsModal open={openBillingModal} onClose={() => setOpenBillingModal(false)}
                    billingData={billingDetails} planData={PlanDataState} payAdvice={PayAdvice} payGenerate={PayGenerate} pendingDetails={PendingDetails}
                    summaryReport={SummaryReport} messPlan={selectedMessPlan} transPlan={selectedTransPlan} receiptSummary={ReceiptSummary}
                />
                <Dialog
                    open={OpenDForDelete}
                    onClose={handleCancelDButton}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" >
                        Do You Want To Delete The Transaction ?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleConfirmDDelete}
                        >
                            Yes
                        </Button>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleCancelDButton}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={OpenDForCancel}
                    onClose={handleCancelCButton}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" >
                        {TransactionData[0]?.BookSt === "B" ? "Do You Want To Cancel The Transaction" : "Do You Want To Restore The Transaction"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleConfirmCancel}
                        >
                            Yes
                        </Button>
                        <Button
                            sx={{
                                backgroundColor: '#635bff',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    color: 'white'
                                }
                            }}
                            onClick={handleCancelCButton}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Grid container spacing={1} className="rasidant_grid" >

                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Pre-Checkin
                        </Typography>
                        {/* <Button
                            variant="contained"
                            size="small"
                            sx={{
                                minWidth: '80px',
                                padding: '4px 8px',
                                fontSize: '0.8rem',
                                lineHeight: 1.2,
                                backgroundColor: '#ff9800',
                                fontWeight: 'bold',
                                marginRight: '5px',
                                '&:hover': { backgroundColor: '#f57c00' },
                                display: watch("BookStatus") === "Checked In" && watch("bookingType") === "new" ? 'inline-flex' : 'none'
                            }}
                            onClick={ToRenewnavigation}
                        >
                            To Renew
                        </Button> */}

                        {/* <Button
                            variant="contained"
                            size="small"
                            sx={{
                                minWidth: '80px',
                                padding: '4px 8px',
                                fontSize: '0.8rem',
                                lineHeight: 1.2,
                                backgroundColor: '#4caf50',
                                fontWeight: 'bold',
                                '&:hover': { backgroundColor: '#388e3c' },
                                display: watch("BookStatus") === "Checked In" && watch("bookingType") === "new" ? 'inline-flex' : 'none'
                            }}
                            onClick={ToExtendavigation}
                        >
                            To Extend
                        </Button> */}
                        {TransactionData[0]?.BookSt === "C" && (
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    minWidth: '80px',
                                    padding: '7px 10px',
                                    fontSize: '0.8rem',
                                    lineHeight: 1.2,
                                    backgroundColor: '#d2731a',
                                    fontWeight: 'bold',
                                    '&:hover': { backgroundColor: '#d9570c' },
                                }}
                                onClick={CancelConfirmation}
                            >
                                Cancel Confirmation
                            </Button>
                        )}

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Pre-Checkin"
                                mode={Mode}
                                onAdd={handleAddClick}
                                onEdit={handleEditClick}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleClickBackToTable}
                                readOnlyMode={!AllDisUnable}
                                onPrevious={handlePrevClick}
                                onNext={handleNextClick}
                                hideDelete={true}
                                hideAdd={true}
                            />
                        </Grid>
                    </Grid>


                    <Grid item xs={12} className="form_field" sx={{ borderRadius: 2, padding: 3 }} >
                        <Grid container spacing={0.5} >

                            <Grid item xs={12} md={12}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    {/* BookStatus on the left */}
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flex: 1,
                                        minWidth: '200px',
                                        gap: 2
                                    }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                Book Status:
                                            </Typography>
                                            <Typography variant="body1"
                                                sx={{
                                                    marginLeft: '10px',
                                                    fontWeight: 'bold',
                                                    color: 'purple'
                                                }}>
                                                {watch("BookStatus")}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                Booking Type:
                                            </Typography>
                                            <Typography variant="body1"
                                                sx={{
                                                    marginLeft: '10px',
                                                    fontWeight: 'bold',
                                                    color:
                                                        !TransactionData[0]?.BookingType ? 'green' :
                                                            TransactionData[0]?.BookingType === 'new' ? 'green' :
                                                                TransactionData[0]?.BookingType === 'renewal' ? 'orange' :
                                                                    'blue'
                                                }}>
                                                {TransactionData[0]?.BookingType || 'New'}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Links on the right */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', textDecoration: 'none', }}>

                                        <Link
                                            // to="/advicegeneratetable"
                                            to={`/advicegeneratetable?bookNo=${watch('BookNo')}`}
                                            sx={{

                                                cursor: 'pointer',
                                                textDecoration: 'none'
                                            }}
                                        >
                                            {/* <Typography
                                                sx={{
                                                    display: 'flex',
                                                    background: '#5c6bc0',
                                                    color: 'white',
                                                    padding: '0px 5px',
                                                    borderRadius: '5px',
                                                }}


                                            >
                                                <PaymentsIcon sx={{ mr: 0.5 }} />
                                                Pyt Advice
                                            </Typography> */}
                                            <Tooltip
                                                title={permissions.ViewRec !== "1" ? "You don't have permission to view this" : ""}
                                                arrow
                                            >
                                                <span>
                                                    <Typography
                                                        sx={{
                                                            display: 'flex',
                                                            background: permissions.ViewRec === "1" ? '#5c6bc0' : '#9e9e9e',
                                                            color: 'white',
                                                            px: 1,
                                                            borderRadius: '5px',
                                                            cursor: permissions.ViewRec === "1" ? 'pointer' : 'not-allowed',
                                                            opacity: permissions.ViewRec !== "1" ? 0.6 : 1
                                                        }}
                                                        onClick={(e) => {
                                                            if (permissions.ViewRec !== "1") {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    >
                                                        <PaymentsIcon sx={{ mr: 0.5 }} />
                                                        Pyt Advice
                                                    </Typography>
                                                </span>
                                            </Tooltip>

                                        </Link>


                                        <Typography
                                            to="#"
                                            onClick={handleEmailSentLink}
                                            sx={{ padding: '0px 10px', textDecoration: 'none', cursor: 'pointer' }}
                                        >
                                            <Typography sx={{
                                                display: 'flex',

                                                background: '#4caf50',
                                                padding: '0px 5px',
                                                borderRadius: '5px',
                                                color: 'white'
                                            }}>

                                            </Typography>

                                        </Typography>
                                        <Typography
                                            to="#"
                                            onClick={handleBookingHistoryClick}
                                            sx={{ textDecoration: 'none', cursor: 'pointer' }}
                                        >
                                            <Typography sx={{
                                                display: 'flex',
                                                background: '#7d8382',
                                                color: 'white',
                                                padding: '0px 5px',
                                                borderRadius: '5px',
                                            }}

                                            >  <HistoryIcon fontSize="small" sx={{ mr: 0.5 }} />  Booking History </Typography>

                                        </Typography>

                                        <Typography
                                            to="#"
                                            onClick={handleClickCancelBooking}
                                            sx={{ textDecoration: 'none', cursor: 'pointer' }}
                                        >
                                            {/* {Mode === "view" && TransactionData[0]?.BookSt === "B" ? "Booking Cancel" : Mode === "view" && TransactionData[0]?.BookSt === "X" ? "Booking Restore " : ""} */}
                                            <Typography
                                                sx={{
                                                    display: 'flex',
                                                    background: '#ed453c',
                                                    color: 'white',
                                                    padding: '0px 5px',
                                                    borderRadius: '5px',
                                                    marginLeft: '10px'
                                                }}
                                            >
                                                {Mode === "view" && TransactionData[0]?.BookSt === "B" ? (
                                                    <>
                                                        <CancelIcon fontSize="small" sx={{
                                                            mr: 0.5,

                                                        }} /> Booking Cancel
                                                    </>
                                                ) : Mode === "view" && TransactionData[0]?.BookSt === "X" ? (
                                                    <>
                                                        <RestoreIcon fontSize="small" sx={{
                                                            mr: 0.5,

                                                        }} /> Booking Restore
                                                    </>
                                                ) : null}
                                            </Typography>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl variant="outlined" fullWidth>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <div
                                                    style={{
                                                        width: 25,
                                                        height: 15,
                                                        backgroundImage: `url(${selectedImage})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        borderRadius: '4px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                />
                                            </InputAdornment>
                                        }
                                        aria-describedby="outlined-weight-helper-text"
                                        style={{ width: "100%", height: 40 }}
                                        inputProps={{
                                            'aria-label': 'weight',
                                            // style: { height: 40 },
                                        }}
                                        placeholder={`Enter Valid ${MobDigit} digit Mobile Number`}
                                        onChange={(e) => { handleMobileChange(e, "add") }}
                                        value={watch('MobileNo') || OcupntMob || mobileNoFromQuery || ''}
                                        disabled={Mode === "view" ? true : !AllDisUnable ? true : false}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="BookNo"
                                    name="BookNo"
                                    label="Booking No"
                                    variant="filled"
                                    fullWidth
                                    value={watch('BookNo') || ''}
                                    disabled={Mode === "view" ? true : !AllDisUnable ? true : false}
                                    className="custom-textfield"
                                    {...register('BookNo', { onChange: (e) => handleBookNoChange(e, 'A') })}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} >
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="companyName-select-label">
                                        <span>
                                            Property List    <span style={{ color: "red" }}>*</span>
                                        </span>
                                    </InputLabel>
                                    <Select
                                        labelId="companyName-select-label"
                                        id="PropId"
                                        name="PropId"
                                        value={watch('PropId') || ''}
                                        className="custom-textfield"

                                        {...register('PropId')}
                                        onChange={handlePropertyChange}
                                        disabled={Mode === "view" ? true : !AllDisUnable ? true : false}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200, // Set the maximum height for the dropdown menu
                                                    overflow: "auto", // Allow scrolling if content exceeds the max height
                                                },
                                            },
                                        }}
                                    >
                                        {PropertyDrp.length > 0 && PropertyDrp?.map((type) => (
                                            <MenuItem key={type.Id} value={type.Id}>
                                                {type.Name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>



                            <Grid item xs={12} md={2}>

                                <DatePicker
                                    label="Booking Date"
                                    value={dayjs(watch('BookDt'))}
                                    // onChange={(newValue) => {
                                    //     setValue('BookDt', newValue ? newValue.format("YYYY-MM-DD") : "");
                                    // }}
                                    onChange={(newValue) => {
                                        const dateStr = newValue ? newValue.format("YYYY-MM-DD") : "";
                                        setValue('BookDt', dateStr);
                                        setValue('BookDtFrom', dateStr);
                                    }}
                                    format="DD/MM/YYYY"
                                    views={['day', 'month', 'year']}
                                    disabled={true}
                                    variant="filled"
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            height: '40px'
                                        }
                                    }}

                                />
                            </Grid>
                            {/* Name Field */}


                            <Grid item xs={12} md={4} sm={2}  >
                                <TextField
                                    id="FirstName"
                                    name="FirstName"
                                    label="First Name"
                                    variant="filled"
                                    fullWidth
                                    value={watch('FirstName') || ''}
                                    className="custom-textfield"
                                    {...register('FirstName')}
                                    disabled={true}

                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={2} >
                                <TextField
                                    id="LastName"
                                    name="LastName"
                                    label="Last Name"
                                    variant="filled"
                                    fullWidth
                                    value={watch('LastName') || ''}
                                    className="custom-textfield"
                                    {...register('LastName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="Email"
                                    name="Email"
                                    label="Email"
                                    variant="filled"
                                    fullWidth
                                    value={watch('Email') || ''}
                                    className="custom-textfield"
                                    {...register('Email')}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="BookRef"
                                    name="BookRef"
                                    label="Referred By"
                                    variant="filled"
                                    fullWidth
                                    value={watch('BookRef') || ''}
                                    className="custom-textfield"
                                    {...register('BookRef')}
                                    disabled={!AllDisUnable}

                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <DatePicker
                                    label="Check-In Date"
                                    value={dayjs(watch('CheckinDt'))}
                                    onChange={(newValue) => {
                                        setValue('CheckinDt', newValue ? newValue.format("YYYY-MM-DD") : "");
                                    }}

                                    format="DD/MM/YYYY"
                                    views={['day', 'month', 'year']}
                                    disabled={!AllDisUnable}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            height: '40px'
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="Duration"
                                    name="Duration"
                                    label={
                                        <span>
                                            Duration <span style={{ color: "red" }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    value={watch('Duration') || ''}
                                    className="custom-textfield"
                                    {...register('Duration')}
                                    onChange={handlePropertyChange}
                                    disabled={!AllDisUnable}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <DatePicker
                                    label="Booking Up To"
                                    value={watch('BookUpToDt') ? dayjs(watch('BookUpToDt')) : dayjs()}
                                    onChange={(newValue) => {
                                        setValue('BookUpToDt', newValue ? newValue.format("DD/MM/YYYY") : "");
                                    }}
                                    format="DD/MM/YYYY"
                                    views={['day', 'month', 'year']}
                                    disabled={true}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            height: '40px'
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>

                                <DatePicker
                                    label="CheckoutDt"
                                    value={watch('CheckoutDt') ? dayjs(watch('CheckoutDt')) : dayjs()}
                                    onChange={(newValue) => {
                                        setValue('CheckoutDt', newValue ? newValue.format("DD/MM/YYYY") : "");
                                        setBillFunc();
                                    }}
                                    format="DD/MM/YYYY"
                                    views={['day', 'month', 'year']}
                                    disabled={!AllDisUnable}
                                    sx={{
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                            height: '40px'
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sx={{ display: "flex", justifyContent: 'flex-start', alignItems: 'center' }}>


                                <Button
                                    variant="contained"
                                    size="medium"
                                    sx={{
                                        backgroundColor: "#635bff",
                                        height: 35,
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        marginLeft: '10px'
                                    }}
                                    onClick={() => {
                                        if (!watch('PropId')) {
                                            toast.info("Please select a property first");
                                            return;
                                        }
                                        if (!watch('BookDtFrom') || !watch('BookUpToDt')) {
                                            toast.info("Please set booking dates first");
                                            return;
                                        }

                                        setValue("BedCatId", "");
                                        setValue("RoomTypeId", "");
                                        setValue("RoomBedTypeId", "");

                                        fetchCategoryData();
                                        setOpenCategoryModal(true);
                                    }}
                                    disabled={!AllDisUnable}
                                >
                                    Change Category
                                </Button>
                            </Grid>

                            <Grid item xs={12} md={2} sm={2}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="companyName-select-label"> Payment Plan <span style={{ color: 'red' }}>*</span> </InputLabel>
                                    <Select
                                        labelId="companyName-select-label"
                                        id="RoomPlanId"
                                        name="RoomPlanId"
                                        value={watch('RoomPlanId') || ''}
                                        className="custom-textfield"
                                        {...register('RoomPlanId')}
                                        onChange={(e) => handlePlanChange(e.target.value)}
                                        disabled={!AllDisUnable}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    overflow: "auto",
                                                },
                                            },
                                        }}

                                    >
                                        {PlanDrp?.map((type) => (
                                            <MenuItem key={type.RoomPlanID} value={type.RoomPlanID}>
                                                {type.PlanName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="RoomTypeName"
                                    name="RoomTypeName"
                                    label="Room Type"
                                    variant="filled"
                                    fullWidth
                                    value={watch('RoomTypeName') || ''}
                                    className="custom-textfield"
                                    {...register('RoomTypeName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="RoomViewNAme"
                                    name="RoomViewNAme"
                                    label="View"
                                    variant="filled"
                                    fullWidth
                                    value={watch('RoomViewNAme') || ''}
                                    className="custom-textfield"
                                    {...register('RoomViewNAme')}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="RoomBedTypeName"
                                    name="RoomBedTypeName"
                                    label="Bed Type"
                                    variant="filled"
                                    fullWidth
                                    value={watch('RoomBedTypeName') || ''}
                                    className="custom-textfield"
                                    {...register('RoomBedTypeName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="RoombedName"
                                    name="RoombedName"
                                    label="Bed No"
                                    variant="filled"
                                    fullWidth
                                    value={watch('RoombedName') || ''}
                                    className="custom-textfield"
                                    {...register('RoombedName')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="BedRent"
                                    name="BedRent"
                                    label="Standard Rent"
                                    variant="filled"
                                    fullWidth
                                    value={watch('BedRent') || ''}
                                    className="custom-textfield"
                                    {...register('BedRent')}
                                    // disabled={true}
                                    disabled={!AllDisUnable}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        backgroundColor: "#2e7d32",
                                        height: 35,
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        marginLeft: '13px',
                                        '&:hover': {
                                            backgroundColor: "#1b5e20",
                                        }
                                    }}
                                    disabled={!AllDisUnable}
                                    onClick={handleClickCheckAvaCal}
                                >
                                    Room Availability
                                </Button>
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="PlanTenur"
                                    name="PlanTenur"
                                    label="Tenure"
                                    variant="filled"
                                    fullWidth
                                    value={watch('PlanTenur')}
                                    className="custom-textfield"
                                    {...register('PlanTenur')}
                                    disabled={true}

                                />
                            </Grid>
                            <Grid item xs={12} md={1.5} sm={2} >
                                <TextField
                                    id="FreeMonth"
                                    name="FreeMonth"
                                    label="FreeMonth"
                                    variant="filled"
                                    fullWidth
                                    value={watch('FreeMonth')}
                                    className="custom-textfield"
                                    {...register('FreeMonth')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={1.5} sm={2} >
                                <TextField
                                    id="MinAdjMonths"
                                    name="MinAdjMonths"
                                    label="MinAdvMonth"
                                    variant="filled"
                                    fullWidth
                                    value={watch('MinAdjMonths')}
                                    className="custom-textfield"
                                    {...register('MinAdjMonths')}
                                    disabled={true}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={1.5} sm={2} >
                                <TextField
                                    id="IncRentPerc"
                                    name="IncRentPerc"
                                    label="Increase (%)"
                                    variant="filled"
                                    fullWidth
                                    value={watch('IncRentPerc')}
                                    className="custom-textfield"
                                    {...register('IncRentPerc')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={1.5} sm={2} >
                                <TextField
                                    id="DepositAmt"
                                    name="DepositAmt"
                                    label="Deposit"
                                    variant="filled"
                                    fullWidth
                                    value={watch('DepositAmt')}
                                    className="custom-textfield"
                                    {...register('DepositAmt')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="CouponNo"
                                    name="CouponNo"
                                    label="Coupon"
                                    variant="filled"
                                    fullWidth
                                    value={watch('CouponNo') || ''}
                                    className="custom-textfield"
                                    {...register('CouponNo')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            background: '#2f25e0ff',
                                            height: 35,
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                            marginRight: '0px',
                                            '&:hover': {
                                                background: '#2f25e0ff',
                                            }
                                        }}
                                        disabled={!AllDisUnable || couponStatus === 'unavailable'}
                                        onClick={handleApplyCoupon}
                                    >
                                        Apply Coupon
                                    </Button>

                                    {couponStatus === 'checking' && (
                                        <CircularProgress size={20} sx={{ color: '#635bff' }} />
                                    )}

                                    {couponStatus === 'available' && (
                                        <CheckCircleIcon sx={{ color: 'green', fontSize: 24 }} />
                                    )}

                                    {couponStatus === 'unavailable' && (
                                        <CancelIcon sx={{ color: 'red', fontSize: 24 }} />
                                    )}

                                    {couponStatus !== 'checking' && (
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                mr: 1,
                                                color: couponStatus === 'available' ? 'green' : 'red',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {couponStatus === 'available' ? 'Available' : 'Unavailable'}
                                        </Typography>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={2} sm={2}>
                                <TextField
                                    id="DiscType"
                                    name="DiscType"
                                    label="Discount Type"
                                    variant="filled"
                                    fullWidth
                                    value={(() => {
                                        const discType = watch('DiscType');
                                        const amtDiscount = watch('AMTDISCOUNT');

                                        if (discType === "F") {
                                            return amtDiscount === undefined ? 'FreeMonth (0)' : `FreeMonth (${amtDiscount})`;
                                        } else if (discType === "M") {
                                            return amtDiscount === undefined ? 'Monthly (0)' : `Monthly (${amtDiscount})`;
                                        } else if (discType === "L") {
                                            return "LumpSum";
                                        }
                                        return '';
                                    })()}
                                    className="custom-textfield"
                                    {...register('DiscType')}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="DiscAmt"
                                    name="DiscAmt"
                                    label="Discount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('DiscAmt')}
                                    className="custom-textfield"
                                    {...register('DiscAmt')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="TotalRent"
                                    name="TotalRent"
                                    label="Total Rent"
                                    variant="filled"
                                    fullWidth
                                    value={watch('TotalRent')}
                                    {...register('TotalRent')}
                                    className="custom-textfield"
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="NetAmt"
                                    name="NetAmt"
                                    label="Net Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('NetAmt')}
                                    className="custom-textfield"
                                    {...register('NetAmt')}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="MonthlyAmt"
                                    name="MonthlyAmt"
                                    label="Effective Rent "
                                    variant="filled"
                                    fullWidth
                                    value={watch('MonthlyAmt')}
                                    {...register('MonthlyAmt')}
                                    className="custom-textfield"
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="AdvcRcble"
                                    name="AdvcRcble"
                                    label="Net Payable"
                                    variant="filled"
                                    fullWidth
                                    value={watch('AdvcRcble')}
                                    {...register('AdvcRcble')}
                                    className="custom-textfield"
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="companyName-select-label">
                                        <span>
                                            Bill Cycle    <span style={{ color: "red" }}>*</span>
                                        </span>
                                    </InputLabel>
                                    <Select
                                        labelId="companyName-select-label"
                                        id="BillCycle"
                                        name="BillCycle"
                                        value={watch('BillCycle') || ''}
                                        className="custom-textfield"
                                        {...register('BillCycle')}


                                        disabled={!AllDisUnable}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    overflow: "auto",
                                                },
                                            },
                                        }}
                                    >

                                        <MenuItem key="F" value="F">
                                            First
                                        </MenuItem>
                                        <MenuItem key="S" value="S">
                                            Second
                                        </MenuItem>

                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={1}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="companyName-select-label">
                                        <span>
                                            TopUp Days  <span style={{ color: "red" }}>*</span>
                                        </span>
                                    </InputLabel>
                                    <Select
                                        labelId="companyName-select-label"
                                        id="Topupdays"
                                        name="TopupId"
                                        value={watch('TopupId') || ''}
                                        className="custom-textfield"
                                        {...register('TopupId')}
                                        onChange={handleTopUpChange}
                                        disabled={!AllDisUnable}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    overflow: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        {TopUpDrp.length > 0 && TopUpDrp?.map((type) => (
                                            <MenuItem key={type.TopupID} value={type.TopupID}>
                                                {type.Topupdays || 0}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12} md={1} sm={2} >
                                <TextField
                                    id="TopupAmt"
                                    name="TopupAmt"
                                    label="TopUp Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('TopupAmt') || 0}
                                    className="custom-textfield"
                                    {...register('TopupAmt')}
                                    disabled={true}

                                />
                            </Grid>
                            <Grid item xs={12} md={2} sm={2}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="TransPlanId-select-label"> AddOn1 </InputLabel>
                                    <Select
                                        labelId="TransPlanId-select-label"
                                        id="TransPlanId"
                                        name="TransPlanId"
                                        value={watch('TransPlanId') || ''}
                                        className="custom-textfield"
                                        {...register('TransPlanId')}
                                        onChange={handleTopUpChange}
                                        disabled={!AllDisUnable}

                                    >
                                        {TransPlanDrp?.map((type) => (
                                            <MenuItem key={type.Id} value={type.Id}>
                                                {type.TransPlanName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="TrspChrg"
                                    name="TrspChrg"
                                    label="Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('TrspChrg')}
                                    className="custom-textfield"
                                    {...register('TrspChrg')}
                                    disabled={true}

                                />
                            </Grid>

                            <Grid item xs={12} md={2} sm={2}>
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="MessPlanId-select-label">AddOn2</InputLabel>
                                    <Select
                                        labelId="MessPlanId-select-label"
                                        id="MessPlanId"
                                        name="MessPlanId"
                                        value={watch('MessPlanId') || ''}
                                        className="custom-textfield"
                                        {...register('MessPlanId')}
                                        disabled={!AllDisUnable}
                                        onChange={handleTopUpChange}
                                    >
                                        {MessPlanDrp?.map((type) => (
                                            <MenuItem key={type.MessPlanID} value={type.MessPlanID}>
                                                {type.MessPlanName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="MessChrg"
                                    name="MessChrg"
                                    label="Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch('MessChrg')}
                                    className="custom-textfield"
                                    {...register('MessChrg')}

                                    disabled={true}

                                />
                            </Grid>

                            <Grid item xs={12} md={4} lg={4}>
                                <TextField
                                    fullWidth
                                    label="Remark"
                                    name="BookRemark"
                                    multiline
                                    rows={1}
                                    variant="filled"
                                    className="custom-textfield"
                                    value={watch('BookRemark') || ''}
                                    disabled={!AllDisUnable}
                                    {...register('BookRemark')}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: "60px",

                                            display: "flex",
                                            alignItems: "center",
                                            padding: "12px",
                                        },
                                        "& .MuiInputBase-input": {
                                            resize: "vertical",
                                            padding: "8px",
                                            display: "flex",
                                            alignItems: "center",
                                        },
                                        "& .MuiFilledInput-root": {
                                            "&:hover": {
                                                backgroundColor: "transparent",
                                            },
                                            "&.Mui-focused": {
                                                backgroundColor: "transparent",
                                            },
                                        },
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} sm={2} >
                                <FormControl variant="outlined" fullWidth>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"

                                        startAdornment={
                                            <InputAdornment position="start" sx={{ width: 'auto', padding: '0 -30px' }}>
                                                <CurrencyRupeeIcon />
                                            </InputAdornment>
                                        }
                                        aria-describedby="outlined-weight-helper-text"
                                        style={{
                                            width: '100%',
                                            height: 40,
                                            maxWidth: '100%',
                                            overflow: 'hidden',
                                            // textOverflow: 'ellipsis', // Shows ellipsis if content exceeds input width

                                        }}
                                        inputProps={{
                                            'aria-label': 'weight',
                                            style: {
                                                height: 50,
                                                padding: '12px 14px',
                                                fontSize: fontSize,
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis', // Truncate overflowed content with ellipsis
                                            },
                                        }}
                                        {...register("AmtInWor")}

                                        value={watch('AmtInWor') || ''}
                                        disabled={true}
                                        readOnly
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={2} sm={2} >
                                <TextField
                                    id="TotNetAmt"
                                    name="TotNetAmt"
                                    label="Total Amount"
                                    variant="filled"
                                    fullWidth
                                    value={watch("TotNetAmt")}
                                    className="custom-textfield"
                                    {...register('TotNetAmt')}
                                    disabled={true}

                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">

                        {/* {Mode === "view" && ( */}
                        <Tooltip title="View Billing Details" arrow>
                            <span>
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        backgroundColor: "#635bff",
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        mr: 1
                                    }}
                                    onClick={handleBillingDetails}
                                >
                                    Acc View
                                </Button>
                            </span>
                        </Tooltip>
                        {/* )} */}
                        {/* {Mode === "view" && ( */}
                        <Tooltip title={regenerate ? 'Click to regenerate account' : 'Generate account'} arrow>
                            <span>
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        backgroundColor: "#635bff",
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        mr: 1
                                    }}
                                    onClick={() => setOpenConfirmGen(true)}
                                >
                                    {regenerate ? 'Acc ReGen' : 'Acc Gen'}
                                </Button>
                            </span>
                        </Tooltip>
                        {/* )} */}
                        <Dialog open={openConfirmGen} onClose={() => setOpenConfirmGen(false)}>
                            <DialogTitle>Confirmation</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Are you sure you want to {regenerate ? 're-generate' : 'generate'} the account?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    color='success'
                                    onClick={() => {

                                        handleAccountGenerateClick();
                                        setOpenConfirmGen(false);
                                    }}
                                    autoFocus
                                >
                                    Yes
                                </Button>
                                <Button
                                    color='error'
                                    onClick={() => setOpenConfirmGen(false)}
                                >
                                    No
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                mr: 1,
                                background: 'linear-gradient(290deg, #635bff", #635bff")'
                            }}
                            onClick={handleSubmitClick}
                            disabled={!AllDisUnable || isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                mr: 1,
                                background: 'linear-gradient(290deg, #635bff", #635bff")'
                            }}
                            disabled={!AllDisUnable}
                            onClick={handleCancelClick}
                        >
                            Cancel
                        </Button>
                    </Grid>

                </Grid>
                <div style={{ display: 'none' }}>
                    {<BReport contentRef={contentRef} DataObj={watch()} />}

                </div>
                <Dialog
                    open={openRenewalPopup}
                    onClose={() => {
                        setOpenRenewalPopup(false);
                        setRenewalData(null);
                    }}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px 24px'
                    }}>
                        Previous Booking Details
                        <Button
                            onClick={() => setOpenRenewalPopup(false)}
                            sx={{
                                minWidth: 'auto',
                                padding: '4px',
                                backgroundColor: '#1976d2',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                }
                            }}
                        >
                            Close
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        {renewalData ? (
                            <TableContainer>
                                <Table sx={{
                                    '& .MuiTableCell-root': {
                                        padding: 0,
                                        border: '1px solid rgba(224, 224, 224, 1)'
                                    }
                                }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Booking No</TableCell>
                                            <TableCell>Check-In Date</TableCell>
                                            <TableCell>Check-Out Date</TableCell>
                                            <TableCell>Unit</TableCell>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Status</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {renewalData.map((booking, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{booking.BookNo}</TableCell>
                                                <TableCell>
                                                    {moment(booking.BookDtFrom).format("DD-MM-YYYY")}
                                                </TableCell>
                                                <TableCell>
                                                    {moment(booking.BookUpToDt).format("DD-MM-YYYY")}
                                                </TableCell>
                                                <TableCell>
                                                    {booking.RoomBedName}
                                                </TableCell>
                                                <TableCell>
                                                    {booking.ResidentName}
                                                </TableCell>
                                                <TableCell>{booking.BookStatus}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Typography>No previous bookings found</Typography>
                        )}
                    </DialogContent>

                </Dialog>

                <Dialog
                    open={openCategoryModal}
                    onClose={() => setOpenCategoryModal(false)}
                    maxWidth="lg"
                    fullWidth
                    //   fullScreen
                    sx={{
                        '& .MuiDialog-container': {
                            alignItems: 'flex-start'
                        }
                    }}
                >
                    <DialogTitle
                        style={{
                            padding: '30px 20px',
                            height: '40px',
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: 'sticky',
                            top: 0,
                            backgroundColor: 'white',
                            zIndex: 1,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <Typography variant="h6">Category Selection</Typography>

                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Tooltip title='Refresh to check latest' arrow>
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        background: '#635bff',
                                        height: '35px',
                                        color: 'white',
                                        borderRadius: '5px',
                                        textTransform: 'none',
                                    }}
                                    onClick={handleRefresh}
                                >
                                    Refresh
                                </Button>
                            </Tooltip>
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    background: '#635bff',
                                    height: '35px',
                                    color: 'white',
                                    borderRadius: '5px',
                                }}
                                onClick={() => setOpenCategoryModal(false)}
                            >
                                <CancelPresentationIcon />
                            </Button>
                        </Box>
                    </DialogTitle>

                    <DialogContent sx={{
                        padding: 0,
                        height: 'calc(100vh - 120px)',
                        overflow: 'hidden'
                    }}>
                        {categoryLoader ? (
                            <Box sx={{
                                display: 'flex',
                                justifyContent: "center",
                                alignItems: "center",
                                height: '100%'
                            }}>
                                <CircularProgress />
                            </Box>
                        ) : (
                            <Paper sx={{
                                width: "100%",
                                height: "100%",
                                overflow: "hidden",
                                margin: "0px auto",
                                backgroundColor: "#ffffff",
                                borderRadius: 0,
                                boxShadow: "none",
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <TableContainer sx={{
                                    flex: 1,
                                    overflow: 'auto'
                                }}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                {categoryColumns.map((column) => (
                                                    <TableCell
                                                        key={column.id}
                                                        align="center"
                                                        sx={{
                                                            minWidth: column.minWidth,
                                                            backgroundColor: "#dddbff"
                                                        }}
                                                    >
                                                        <Typography variant="subtitle1" fontWeight="bold">
                                                            {column.label}
                                                        </Typography>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {categoryRows.map((row, index) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={index}
                                                        onDoubleClick={() => {
                                                            setValue("RoomTypeName", row.RoomTypeName);
                                                            setValue("RoomViewNAme", row.RoomViewName);
                                                            setValue("RoomBedTypeName", row.RoomBedTypeName);
                                                            setValue("BedRent", row.BedRent);

                                                            // Store the IDs in state or directly in form values
                                                            setValue("BedCatId", row.BedCatId);
                                                            setValue("RoomTypeId", row.RoomTypeId);
                                                            setValue("RoomBedTypeId", row.RoomBedTypeId);
                                                            setOpenCategoryModal(false);
                                                            fetchTopUpData(row.RoomTypeId, "button");
                                                        }}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {categoryColumns.map((column) => {
                                                            const value = row[column.id];
                                                            return (
                                                                <TableCell
                                                                    key={column.id}
                                                                    align="center"
                                                                    sx={{
                                                                        padding: "4px",
                                                                        border: "0.5px solid #ddd"
                                                                    }}
                                                                >
                                                                    {column.id.startsWith('year_') ? (
                                                                        <div style={{ fontWeight: 'bold' }}>{value}</div>
                                                                    ) : column.id.match(/^\d{4}-[A-Za-z]+$/) ? (
                                                                        <div style={{
                                                                            //   backgroundColor: getBackgroundColor(value),
                                                                            //   color: getTextColor(value),
                                                                            fontWeight: 'bold',
                                                                            borderRadius: '4px'
                                                                        }}>
                                                                            {value || 0}
                                                                        </div>
                                                                    ) : (
                                                                        value
                                                                    )}
                                                                </TableCell>
                                                            );
                                                        })}
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        )}
                    </DialogContent>
                </Dialog>
                <RoomSelection
                    open={OpenHistoryTable}
                    onClose={handleCloseRoom}
                    propId={watch('PropId')}
                    dateFrom={DateFrom.format('YYYY-MM-DD')}
                    dateTo={DateTo.format('YYYY-MM-DD')}
                    onRoomSelect={handleRowDoubleClick}
                    BedCatId={watch('BedCatId')}
                />
                <Dialog open={openOtpDialog} onClose={() => setOpenOtpDialog(false)}>
                    <DialogTitle sx={{ backgroundColor: '#f44336', color: '#fff', padding: '4px 20px' }}>
                        Cancel Confirmation
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText sx={{ p: 1 }}>
                            Are you sure you want to cancel confirmation?
                        </DialogContentText>
                        <TextField
                            autoFocus
                            label="Enter Verification Code"
                            type="text"
                            className="custom-textfield"
                            fullWidth
                            variant="filled"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {inputValue.length > 0 && (
                                            inputValue === defaultCode ? (
                                                <CheckCircleIcon color="success" />
                                            ) : (
                                                <CancelIcon color="error" />
                                            )
                                        )}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button color="error"
                            variant="contained"
                            size='small'
                            onClick={handleCancelCancellation}>Cancel</Button>
                        <Button
                            onClick={handleConfirmCancellation}
                            color="primary"
                            variant='contained'
                            size='small'
                            disabled={inputValue !== defaultCode}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>

            </Box>
        </LocalizationProvider>
    );
};

export default Precheckin;